const en = {
  'header.customerService': 'Customer service',
  "header.freeShipping": "Free shipping from €{n}",
  'header.login': 'Sign in',
  'header.admin': 'Administration',
  'header.myAccount': 'My account',
  'header.myWishlist': 'My wishlist',
  'header.myOrders': 'My orders',
  'header.logout': 'Sign out',
  'header.parts': 'Spare parts',
  'header.wholeCategory': 'Whole {name} category →',
  'header.brands': 'Brands',
  'header.guides': 'Guides',
  'header.topGuides': 'Most read guides',
  'header.allGuides': 'All guides & advice',
  'header.allBrandsAZ': 'All brands A to Z ({count})',
  'header.removeVehicle': 'Remove vehicle',
  'header.createAccount': 'Create an account',
  'header.brandsAZ': 'Brands A to Z',
  'header.contact': 'Contact',
  'header.language': 'Language',
  'header.searchPlaceholder': 'Search for a part, a brand or a reference',
  'header.searching': 'Searching...',
  'header.noResults': 'No results for "{term}"',
  'header.openProduct': 'Open product page',
  'header.matchesRef': 'Matches {kind}ref.',

  'footer.tagline': '6.7 million car parts in one place',
  'footer.contactUs': 'Contact us',
  'footer.contact': 'Contact',
  'footer.shipping': 'Shipping & tracking',
  'footer.returns': 'Warranty & returns',
  'footer.about': 'About us',
  'footer.sitemap': 'Sitemap',
  'footer.budget': 'Maintenance budget by model',
  'cookies.title': 'Cookies and analytics',
  'cookies.text': 'We use cookies required for the site to work (cart, login) and, with your consent, analytics cookies (Google Analytics, PostHog) to improve OTOPIECES.COM. No advertising. Your choice is kept for 6 months.',
  'cookies.accept': 'Accept all',
  'cookies.refuse': 'Refuse',
  'cookies.customise': 'Customise',
  'cookies.save': 'Save my choices',
  'cookies.necessary': 'Necessary cookies',
  'cookies.necessaryHint': 'always on (cart, session, preferences)',
  'cookies.analytics': 'Analytics',
  'cookies.analyticsHint': 'anonymous browsing statistics (Google Analytics, PostHog)',
  'cookies.close': 'Close',
  'cookies.manage': 'Manage cookies',
  'cookies.statusOn': 'Analytics: enabled. You can change your choice at any time.',
  'cookies.statusOff': 'Analytics: refused. Only necessary cookies are used.',
  'cookies.statusNone': 'You have not made a choice yet: only necessary cookies are active.',
  'footer.securePayments': 'Secure payments:',
  'footer.fastShipping': "Delivery across Europe",
  'footer.rights': '© 2026 OTOPIECES.COM. All rights reserved.',
  'footer.trademarks': 'All trademarks are the property of their respective owners.',

  'common.ref': 'Ref.',
  'common.addToCart': 'Add to cart',
  'common.free': 'Free',
  'common.subtotal': 'Subtotal',
  'common.shipping': 'Shipping',
  'common.total': 'Total',
  'common.vatIncluded': 'VAT included',
  'common.back': 'Back',
  'common.continueShopping': 'Continue shopping',
  'common.outOfStock': 'Out of stock',
  'common.inStock': 'In stock',
  'common.lowStock': 'Only {n} left in stock',
  'common.supplierStock': 'At our supplier · within {n} days',
  'common.compatible': 'Compatible',
  'common.cancel': 'Cancel',
  'common.apply': 'Apply',
  'common.home': 'Home',
  'common.breadcrumb': 'Breadcrumb',
  'common.unit': 'Unit',
  'common.perUnit': '/ unit',
  'common.discount': 'Discount ({code})',
  'common.packAvailable': 'Available as {label}',
  'common.equivalentOther': 'Equivalent from another brand (same OEM ref.)',
  'common.oem': 'OEM ',
  'common.alternative': 'alternative ',
  'common.bestPrice': 'Best market price',
  'common.bestPriceTitle': 'Price compared with {n} competitor(s){date}: OTOPIECES is the cheapest.',
  'common.onDate': ' on {date}',

  'stock.out': 'Out of stock',
  'stock.supplier': { one: 'Available at our supplier — shipped within {n} day', other: 'Available at our supplier — shipped within {n} days' },
  'stock.low': 'Only {n} left in stock',
  'stock.lowSupplier': ' (+{s} at our supplier within {lead} days)',
  'stock.in': 'In stock',

  'product.notFound': 'Product not found',
  'product.backHome': 'Back to home',
  'product.allParts': 'All {brand} parts',
  'product.manufacturerRef': 'Manufacturer ref.:',
  'product.equivalentRef': 'Equivalent reference',
  'product.oemRef': 'OEM manufacturer reference',
  'product.moreOem': { one: '+{n} more OEM ref.', other: '+{n} more OEM refs.' },
  'product.reviews': { one: '{n} review', other: '{n} reviews' },
  'product.compatibleWith': 'Compatible with your ',
  'product.notGuaranteed': 'Not guaranteed for your ',
  'product.ttcExclShipping': 'incl. VAT, excl. shipping',
  'product.tierBadge': '−{pct}% from {n}',
  'product.cheaperAlt': 'Alternative from €{price} by {brand}',
  'product.cheaperAltCompat': 'Compatible alternative from €{price} by {brand}',
  'product.soldBy': 'Sold by',
  'product.soldByDetail': 'Sold in packs of {n}{label} — €{total} {unitLabel}, i.e. €{unit} / unit',
  'product.theN': 'per {n}',
  'product.totalFor': 'Total for {n}:',
  'product.insteadOf': 'instead of €{price}',
  'product.outOfStockHint': 'Temporarily out of stock',
  'product.photoCheck': 'Check my part by photo',
  'product.added': 'Added to cart',
  'product.addPack': 'Add {qty}{label}',
  'product.viewCart': 'View cart',
  'product.delivery': 'Delivery 2-5 days',
  "product.deliverySub": "Free from €{n}",
  'product.return': '14-day returns',
  'product.returnSub': 'Money-back guarantee',
  'product.warranty': '2-year warranty',
  'product.warrantySub': 'Certified parts',
  'product.description': 'Description',
  'product.faqTitle': 'Frequently asked questions about this product',
  'product.share': 'Share',
  'product.shareCopy': 'Copy link',
  'product.shareCopied': 'Link copied',
  'product.specs': 'Specifications',
  'product.compatibleVehicles': 'Compatible vehicles',
  'product.universal': 'Universal product: compatible with all vehicles.',
  'product.allModels': 'All models',
  'spec.manufacturer': 'Manufacturer',
  'spec.reference': 'Reference',
  'spec.otherRefs': 'Other references',
  'spec.oemRefs': 'OEM references',
  'spec.category': 'Category',
  'product.alsoIn': 'Also found in',
  'product.relatedSubs': 'Other {cat} parts',
  'product.relatedAll': 'Whole {cat} category',
  'product.relatedMore': 'See all (+{n})',
  'product.relatedLess': 'See less',
  'product.relatedVehicles': 'Compatible parts by vehicle',
  'product.guides': 'Guides & advice: {part}',
  'product.readGuide': 'Read the guide',
  'cat.popularModels': '{part} for the most popular models',
  'spec.features': 'Features',
  'spec.ean': 'EAN number',
  'spec.condition': 'Condition',
  'spec.new': 'New',
  'spec.soldBy': 'Sold by',
  'spec.packagings': 'Packagings',
  'spec.avgRating': 'Average rating',
  'spec.avgRatingValue': '{r} / 5 ({n} reviews)',
  'spec.warranty': 'Warranty',
  'spec.warrantyValue': '2 years minimum',
  'spec.availability': 'Availability',

  'pack.title': 'Packaging',
  'pack.units': '{n} units · €{price} / unit',
  'pack.unitPrice': 'Unit price',
  'pack.insufficient': ' · insufficient stock',
  'tiers.title': 'Volume pricing — buy more, pay less',
  'tiers.quantity': 'Quantity',
  'tiers.unitPrice': 'Unit price',
  'tiers.saving': 'Saving',
  'tiers.range': '{a} to {b}',
  'tiers.andMore': '{a} and more',
  'tiers.note': 'Discount applied automatically in the cart on the unit price.',
  'pro.ht': 'i.e. €{price} excl. VAT',
  'pro.discount': 'Pro price −{pct}%: €{price} incl. VAT in the cart',
  'wishlist.added': 'Added to your wishlist',
  'wishlist.removed': 'Removed from your wishlist',
  'wishlist.error': 'Unable to update the wishlist',
  'wishlist.remove': 'Remove from wishlist',
  'wishlist.add': 'Add to wishlist',
  'wishlist.inList': 'In my list',
  'wishlist.addToList': 'Add to my list',
  'faq.askPrompt': 'A question about this part? Ask us, we reply within 24 h.',
  'faq.ask': 'Ask a question',
  'faq.title': 'Frequently asked questions',
  'faq.seeAll': 'See all questions ({n})',
  'faq.answerFrom': 'Answer from {author}',
  'tyre.howMany': 'How many tyres?',
  'tyre.one': '1 tyre',
  'tyre.set4': 'Set of 4 tyres',
  'tyre.n': '{n} tyres',
  'tyre.perTyre': '/ tyre',
  'tyre.insufficient': 'Insufficient stock for a set of 4 — contact us for a restock.',
  'equiv.title': 'This part is also available from other brands',
  'equiv.count': { one: '{n} alternative', other: '{n} alternatives' },
  'equiv.cheaper': { one: ' · {n} cheaper', other: ' · {n} cheaper' },
  'equiv.compare': 'Compare side by side ({n})',
  'similar.title': 'Similar products',
  'similar.sub': '— {category} from other brands fitting the same vehicles',
  'similar.subVehicle': '— fitting your {vehicle}',
  'recent.title': 'Recently viewed',
  'recent.clear': 'Clear',
  'fitments.count': '{n} engine(s) · {b} brand(s)',
  'fitments.filter': 'Filter (brand, model, engine)',
  'fitments.models': { one: '· {n} model', other: '· {n} models' },
  'fitments.noMatch': 'No engine matches "{q}".',
  'reviews.title': 'Customer reviews',
  'reviews.outOf5': 'out of 5',
  'reviews.loginPrompt': 'to review a product you ordered.',
  'reviews.login': 'Sign in',
  'reviews.already': 'Thank you, you have already reviewed this product.',
  'reviews.yourRating': 'Your rating *',
  'reviews.titleField': 'Title',
  'reviews.titlePlaceholder': 'Summary in a few words',
  'reviews.comment': 'Comment *',
  'reviews.commentPlaceholder': 'Quality, fitting, value for money...',
  'reviews.published': 'Your review has been published. Thank you!',
  'reviews.empty': 'No reviews yet. Be the first to share your experience!',
  'reviews.sortBy': 'Sort by',
  'reviews.merchantCollected': 'Review collected by the merchant',
  'reviews.verified': 'Verified purchase',
  'reviews.replyFrom': 'Reply from {author}',
  'reviews.sort.recent': 'Most recent',
  'reviews.sort.helpful': 'Most helpful',
  'reviews.sort.photos': 'With photos first',
  'reviews.share': 'Share',
  'home.google.badge': { one: 'on Google · {n} review', other: 'on Google · {n} reviews' },
  'brand.trust.title': 'Trust score',
  'brand.trust.summary': { one: '{n} verified review across {p} rated product(s)', other: '{n} verified reviews across {p} rated product(s)' },
  'brand.trust.recommended': { one: '{n} product recommended by our customers', other: '{n} products recommended by our customers' },
  'product.topBadge': 'Recommended by our customers',
  'product.topBadgeHint': 'Rated {r}/5 from {n} verified reviews',
  'reviews.translate': 'Translate',
  'reviews.translatedByAi': 'Automatically translated',
  'reviews.originalShown': 'Original text',
  'reviews.showOriginal': 'Show original',
  'reviews.showTranslation': 'Show translation',
  'reviews.translateError': 'Translation unavailable',
  'home.google.title': 'Google rating',
  'home.google.count': { one: '{n} Google review', other: '{n} Google reviews' },
  'home.google.link': 'See all reviews on Google',
  'reviews.pendingNotice': 'Thank you! Your review has been received and will be published after a short check by our team.',
  'home.wall.kicker': 'Verified reviews',
  'home.wall.title': 'Drivers trust us',
  'home.wall.summary': { one: 'from {n} verified review', other: 'from {n} verified reviews' },
  'reviews.shareText': 'My review {stars} of {product}: “{comment}”',
  'reviews.shareMine': 'Share your review with friends:',
  'reviews.sort.best': 'Highest rated',
  'reviews.sort.worst': 'Lowest rated',
  'questions.title': 'Questions & answers',
  'questions.ask': 'Ask a question',
  'questions.placeholder': 'E.g.: Does this part fit the estate version? Is a special tool required?',
  'questions.name': 'Your name *',
  'questions.email': 'Your e-mail * (to receive the answer)',
  'questions.notice': 'Your question will be published with our answer. ',
  'questions.notifyEmail': 'You will be notified by e-mail.',
  'questions.emailPrivate': 'Your e-mail stays private.',
  'questions.empty': 'No questions yet. Unsure about compatibility or fitting? Ask us!',
  'questions.yours': 'Your question',
  'questions.helped': 'Was this answer helpful?',
  'gallery.prev': 'Previous photo',
  'gallery.next': 'Next photo',

  'cart.title': { one: 'Your cart ({n} item)', other: 'Your cart ({n} items)' },
  'cart.empty': 'Your cart is empty',
  'cart.discover': 'Discover our products',
  'cart.units': 'units',
  'cart.soldBy': 'Sold by {n}',
  'cart.proPrice': 'pro price',
  'cart.quantity': 'quantity',
  'cart.summary': 'Order summary',
  'cart.promoLogin': 'Have a promo code? Sign in to apply it.',
  "cart.freeShippingLeft": "Only €{amount} more for free shipping!",
  'cart.checkout': 'Checkout',
  'cartDrawer.title': 'My cart',
  'cartDrawer.saveLater': 'Save for later',
  'cartDrawer.fromWishlist': 'From your wishlist',
  'cartDrawer.goCart': 'Go to cart',
  'cartDrawer.checkout': 'Checkout',
  'cart.loginToOrder': 'Sign in to order',
  'cart.guestNotice': 'Your cart will be kept when you sign in or create your account.',
  "cart.freeShipping120": "Free shipping from €{n}",
  'cart.return14': '14-day returns',
  'cart.securePayment': '100% secure payment',
  'promo.placeholder': 'Promo code',
  'promo.invalid': 'Invalid code',
  'promo.remove': 'Remove code',
  'savings.title': 'You save',
  'alt.cheaper': 'Cheaper alternative by {brand}',
  'alt.perUnit': '−€{d} / unit',
  'alt.total': ', −€{s} in total',
  'alt.replace': 'Replace',
  'alt.replaced': '{name} replaced by {alt}',
  'alt.error': 'Replacement failed',

  'checkout.backToCart': 'Back to cart',
  'checkout.stepShipping': 'Shipping',
  'checkout.stepPayment': 'Payment',
  'checkout.stepConfirmation': 'Confirmation',
  'checkout.shippingAddress': 'Shipping address',
  'checkout.savedAddresses': 'My saved addresses',
  'checkout.address': 'Address',
  'checkout.default': ' · default',
  'checkout.defaultBilling': ' · default billing',
  'checkout.manageAddresses': 'Manage my addresses',
  'checkout.firstName': 'First name',
  'checkout.lastName': 'Last name',
  'checkout.email': 'Email',
  'checkout.phone': 'Phone',
  'checkout.addressComplement': 'Address line 2',
  'checkout.complementPlaceholder': 'Flat, floor, building...',
  'checkout.postalCode': 'Postal code',
  'checkout.city': 'City',
  'checkout.otherBilling': 'Bill to a different address',
  'checkout.invoiceFor': '· invoice issued to {company}',
  'checkout.company': 'Company (optional)',
  'checkout.vat': 'EU VAT number (optional)',
  'checkout.continue': 'Continue to payment',
  'checkout.paymentMethod': 'Payment method',
  'checkout.autoPayNotice': 'Delivery to {address} (saved address).',
  'checkout.autoPayEdit': 'Edit address',
  'checkout.card': 'Credit card',
  'checkout.cardInfo': 'Card details will be requested at confirmation.',
  'checkout.ssl': 'SSL secure payment',
  'checkout.requested': { one: '{n} requested', other: '{n} requested' },
  'checkout.available': { one: '{n} available', other: '{n} available' },
  'checkout.fixCart': 'Adjust my cart',
  'checkout.country': 'Delivery country', 'checkout.carrier': 'Delivery method', 'checkout.relay': 'pickup point', 'checkout.errCountry': 'We do not deliver to this country yet. Please choose another delivery country.', 'cart.shippingEstimate': 'Estimate for {country} · {carrier} — carrier and country are chosen at the next step',
  'checkout.tyreFree': 'Free shipping from 2 tyres', 'checkout.relayPick': 'Choose my pickup point', 'checkout.relayChange': 'Change pickup point', 'checkout.relayRequired': 'Please choose a Mondial Relay pickup point on the map.', 'checkout.relayTitle': 'Choose your pickup point',
  'checkout.weightTier': 'weight-based rate ({w} kg)',
  'checkout.processing': 'Processing...',
  'checkout.pay': 'Pay €{amount}',
  'checkout.fastDelivery': 'Fast delivery',
  'checkout.fastDeliverySub': '2-5 working days',
  'checkout.securePayment': 'Secure payment',
  'checkout.sslSub': 'SSL 256-bit',
  'checkout.warranty': 'Warranty',
  'checkout.warrantySub': '2 years minimum',
  'checkout.summary': 'Summary',
  'checkout.qty': 'Qty: {n}',
  'checkout.fitting': 'Fitting at partner centre',
  'checkout.totalHT': 'Total excl. VAT (pro account)',
  'checkout.vatAmount': '· VAT €{amount}',
  'checkout.totalTTC': 'Total incl. VAT',
  'checkout.useWallet': 'Use my store credit (€{amount} available)',
  'checkout.walletUsed': 'Credit used',
  'checkout.toPay': 'Remaining to pay',
  'checkout.confirmed': 'Order confirmed!',
  'checkout.thanks': 'Thank you for your order. A confirmation email has been sent to {email}',
  'checkout.orderNumber': 'Order number',
  'checkout.deliveryTo': 'Delivery to',
  'checkout.viewOrders': 'View my orders',
  'checkout.errRequired': 'The "{field}" field is required',
  'checkout.errPostal': 'Invalid postal code (5 digits expected)',
  'checkout.errEmail': 'Invalid email address',
  'checkout.errPhone': 'Invalid phone number (e.g. 06 12 34 56 78)',
  'checkout.errBilling': 'Incomplete billing address (name or company, address, postal code, city)',
  'checkout.errOrder': 'Error while placing the order',
  'fitting.title': { one: 'Fitting of your {n} tyre', other: 'Fitting of your {n} tyres' },
  'fitting.intro': 'Optional: have your tyres delivered to a partner centre that will fit and balance them. Pick a slot in its calendar or let the centre contact you.',
  'fitting.sorted': ' Centres sorted by reliability then by distance from {place}.',
  'fitting.none': 'No fitting — delivery to the given address',
  'fitting.recommended': 'Recommended',
  'fitting.distance': '{km} km away',
  'fitting.bestRated': 'Best rated near you',
  'fitting.hideReviews': 'Hide reviews',
  'fitting.showReviews': 'See reviews',
  'fitting.reliable': 'Reliable partner',
  'fitting.reliableTitle': 'Centre that quickly confirms its appointments',
  'fitting.online': 'Online slots',
  'fitting.perTyre': '/ tyre',
  'fitting.hidden': { one: '{n} partner centre more than {km} km away is not offered.', other: '{n} partner centres more than {km} km away are not offered.' },
  'fitting.selected': 'Your tyres will be shipped to {name} ({city}). Fitting + balancing: {total} added to the order.',
  'slot.loading': 'Loading slots…',
  'slot.unavailable': 'This centre has not published its slots yet: it will contact you to set the appointment after the order.',
  'slot.choose': 'Choose your slot at {name}',
  'slot.centreProposes': 'The centre will propose a date',
  'slot.info': { one: '{min}-min slots, at the earliest {d} day after the order (tyre delivery time). The centre will confirm the slot by e-mail.', other: '{min}-min slots, at the earliest {d} days after the order (tyre delivery time). The centre will confirm the slot by e-mail.' },
  'slot.chosen': 'Requested slot: {day} at {time} — to be confirmed by the centre.',

  'home.h1': "Car parts online at the best price — spare parts for every make",
  'home.h1Sub': "Over 6,000 models listed: select your vehicle or enter your number plate to find 100% compatible spare parts. Top brands, delivery in 2-5 days, 14-day returns.",
  'home.seoTitle': "Cheap car parts online — Spare parts for all makes | OTOPIECES.COM",
  'home.seoDesc': "Car spare parts at the best price on OTOPIECES.COM: brakes, filters, engine, tyres… Search by vehicle or number plate, delivery in 2-5 days, 14-day returns.",
  'home.seoKeywords': "car parts, spare parts, cheap car parts, car parts online, number plate search, brake pads, oil filter, tyres",
  'home.faqTitle': "Frequently asked questions about buying car parts online",
  'home.faq1q': "How can I be sure a part fits my car?",
  'home.faq1a': "Select your vehicle (make, model, year, engine) or enter your number plate: the catalogue then only shows compatible spare parts, with a “Fits your vehicle” badge on every product page.",
  'home.faq2q': "What are the delivery times and costs?",
  'home.faq2a': "Orders ship within 24-48 h and arrive in 2-5 working days in France (Colissimo, Chronopost or a Mondial Relay pick-up point). Delivery is free above a given order amount and from 2 tyres.",
  'home.faq3q': "Can I return a part that doesn't fit?",
  'home.faq3a': "Yes, you have 14 days after delivery to return a new, unfitted part in its original packaging. Refunds are issued within 14 days of receiving the parcel.",
  'home.faq4q': "Are the parts guaranteed?",
  'home.faq4a': "All spare parts sold on OTOPIECES.COM are new, from leading manufacturers (Bosch, Mann-Filter, TRW, Febi…) and covered by the 2-year legal conformity warranty.",
  'home.faq5q': "Which payment methods do you accept?",
  'home.faq5a': "Payment is made by card (Visa, Mastercard, Apple Pay, Google Pay) through the secure SumUp platform. Your card details never pass through our servers.",
  'home.faq6q': "Do you offer fitting for parts or tyres?",
  'home.faq6a': "Yes, when ordering you can book a fitting slot at one of our partner centres. Your parts are delivered there directly and fitted by a professional.",
  'acc.bankSecureNote': "Your payments are processed securely by SumUp. Cards saved here are a reminder only: just the last 4 digits are kept, never the full number.",
  'new.menu': "New arrivals",
  'new.menuHint': "{n} part(s) added this week",
  'new.title': "New arrivals",
  'new.h1': "New arrivals: parts added in the last {d} days",
  'new.sub': "The latest spare parts added to the catalogue, sorted by date. Select your vehicle to see only compatible parts.",
  'new.days': "{d} days",
  'new.onlyVehicle': "Compatible with my vehicle only",
  'new.selectVehicle': "Select your vehicle to filter compatible new arrivals",
  'new.allCats': "All categories",
  'new.empty': "No new arrivals for these criteria.",
  'new.showAll': "Show all new arrivals",
  'new.seoTitle': "New car parts — latest spare parts added",
  'new.seoDesc': "Discover the car spare parts added in the last {d} days on OTOPIECES.COM: brakes, filters, engine… filter by compatible vehicle.",
  'new.badge': "New",
  'new.homeTitle': "This week's new arrivals",
  'new.homeCount': "{n} part(s) added in the last 7 days",
  'new.homeAll': "All new arrivals",
  'new.subTitleAll': "Get the week's new arrivals by e-mail",
  'new.subTitleCat': "Get “{name}” new arrivals by e-mail",
  'new.subHint': "One e-mail on Mondays, only when there is something new. One-click unsubscribe.",
  'new.subButton': "Subscribe",
  'new.subOk': "Subscription saved",
  'new.subAlready': "You were already subscribed — subscription reactivated",
  'new.subError': "Subscription failed",
  'new.subDone': "Done! New arrivals ({scope}) will be sent every Monday to {email}.",
  'new.subManage': "Manage my subscriptions",
  'new.subRemoved': "Subscription removed",
  'new.subsTitle': "New arrivals by e-mail",
  'new.subsHint': "Every Monday, the parts added to the catalogue in the categories of your choice.",
  'new.subsEmpty': "No subscription. Subscribe from the page",
  'new.subsSince': "Since {d}",
  'new.subsLast': "last sent {d}",
  'common.loadError': "Loading failed. Check your connection and try again.",
  'common.retry': "Retry",
  'product.movedToCategory': "This product is no longer available — here is its category.",
  'home.selectVehicle': 'Select your vehicle',
  'home.brand': 'BRAND',
  'home.model': 'MODEL',
  'home.year': 'YEAR',
  'home.engine': 'ENGINE',
  'home.chooseBrand': 'Choose a brand',
  'home.chooseModel': 'Choose a model',
  'home.chooseYear': 'Choose the year',
  'home.chooseEngine': 'Choose the engine',
  'home.search': 'Search...',
  'home.topBrands': 'Best-selling brands',
  'home.allBrands': 'All brands',
  'home.noBrand': 'No brand found',
  'home.noModel': 'No model found',
  'home.selectModel': 'Select a model',
  'home.selectYear': 'Select a year',
  'home.noEngine': 'No engine available',
  'home.selectedVehicle': 'Selected vehicle',
  'home.orPlate': 'or search by registration plate',
  'home.plateLabel': 'Know your plate? Look it up in our registry',
  'home.searchBtn': 'Search',
  'home.plateRequired': 'Enter your registration number',
  'home.plateNotFound': 'No vehicle found for this plate',
  'home.identified': 'Vehicle identified:',
  'home.simulated': '(simulated identification)',
  'home.seeParts': 'See compatible parts',
  'home.allVehicleBrands': 'All vehicle brands',
  'home.notFoundCar': "Can't find your car in the catalogue?",
  'home.categoriesTitle': 'Find spare parts in the OTOPIECES.COM catalogue',
  'home.moreParts': 'More spare parts',
  'home.accessoriesTitle': 'Car essentials: accessories, cleaning products and tools',
  'home.allSubcategories': 'All subcategories ({n})',
  'home.trust.return': '14-day returns',
  'home.trust.returnSub': 'Money-back guarantee',
  'home.trust.payments': 'Secure payments',
  'home.trust.app': 'A handy app',
  'home.trust.appSub': 'to buy car parts',
  'home.trust.videos': 'Repair videos',
  'home.trust.videosSub': 'Video guides',
  'home.bestsellers': 'OTOPIECES.COM best-sellers: buy spare parts at great prices',
  'home.compatibleParts': 'Parts compatible with your {vehicle}',
  'home.compatibleCount': '{n} compatible parts',
  'home.seeAllCompatible': 'See all compatible parts',
  'home.addedToCart': 'Product added to cart!',
  'home.addError': 'Error adding to cart',
  'home.carBrands': 'Car parts for the most popular car brands',
  'home.topModels': 'Most viewed vehicle models',
  'home.topModelsAll': 'All brands',
  'home.topModelsParts': 'Compatible parts',
  'home.recentVehicles': 'Your recent vehicles',
  'home.recentClear': 'Clear',
  'garage.compareTitle': 'Compare compatible parts',
  'garage.compareButton': 'Compare',
  'garage.compareThird': '+ 3rd vehicle (optional)',
  'garage.budgetTitle': 'Estimated yearly maintenance budget',
  'garage.budgetHint': 'Estimate based on the compatible parts in our catalogue (wear items × usual replacement interval). Median price, or “eco” = cheapest part.',
  'garage.budgetPerYear': ' / year',
  'garage.dropBadge': 'Budget down by {amount}/year since {date}',
  'garage.historyTitle': 'Budget over the last 12 months',
  'garage.historyMedian': 'Estimated budget',
  'garage.historyEco': 'Eco budget',
  'garage.historyEmpty': 'History starts today: one point is recorded every day, the curve will build up over the coming weeks.',
  'garage.historyChange': 'Change over the period',
  'garage.historyAlert': 'Drop alert sent',
  'garage.historyRange': 'Min {min} · Max {max}',
  'garage.budgetEco': 'Eco:',
  'garage.budgetEcoTotal': 'Eco budget:',
  'garage.budgetCoverage': '{n} item(s) estimated out of {total}',
  'garage.budgetNoParts': 'No compatible maintenance part listed for this vehicle yet.',
  'garage.budgetPost': 'Item',
  'garage.budgetInterval': 'Interval',
  'garage.budgetEstimated': 'Median price',
  'garage.budgetPerYearCol': 'Per year',
  'garage.budgetParts': 'compatible part(s)',
  'garage.budgetEvery': 'every {n} year(s)',
  'garage.budgetMissing': 'Not estimated (no compatible part yet):',
  'garage.budgetSeeParts': 'See all compatible parts →',
  'garage.budgetUpcoming': 'To plan within 12 months:',
  'garage.logCol': 'Service log',
  'garage.logReplaced': 'Replaced on…',
  'garage.logNext': 'Up to date · next: {d}',
  'garage.logOverdue': 'Overdue',
  'garage.logEdit': 'edit',
  'garage.logClear': 'Clear',
  'garage.logSaved': 'Service log updated',
  'garage.logError': 'Could not save',
  'garage.logTracked': '{n} item(s) tracked',
  'garage.logHint': 'Enter the date (and mileage) of the last replacement: the next due date is the earliest of date + interval and km + interval (converted with your yearly mileage). The item leaves the “12-month” budget until then; the smoothed yearly budget is unchanged.',
  'garage.logKm': 'km at replacement',
  'garage.logKmCurrent': 'current vehicle km',
  'garage.logKmAt': 'at {km}',
  'garage.logOrKm': 'or {km}',
  'garage.logMileage': '≈ {km} today',
  'garage.logFromOrder': 'bought on OTOPIECES ({d})',
  'garage.carnetPdf': 'Download the service log (PDF)',
  'garage.carnetPdfDone': 'Service log downloaded',
  'garage.carnetEmail': 'E-mail me my service book',
  'garage.carnetEmailDone': 'Service book sent to {email}',
  'home.seeBrands': 'See all {n} brands',
  'home.partsFor': '{brand} car parts',
  'home.models': '{n} models',
  'home.manufacturers': 'Exceptional deals on car parts from the biggest manufacturers',
  'home.articles': 'Everything for your car: expert guides and advice',
  'home.learnMore': 'Learn more',
  'home.aboutTitle': "Car spare parts online: everything to maintain and repair your car",
  'home.about1a': "OTOPIECES.COM is your online shop for ",
  'home.about1b': "cheap car spare parts",
  'home.about1c': ": brakes (discs, pads, calipers), filters (oil, air, cabin, fuel), engine, suspension, steering, lighting, exhaust, tyres and wheels. Whether you are a private motorist, a DIY enthusiast or a garage, you will find the right part for your vehicle at the best price.",
  'home.about2a': "Every reference is checked for ",
  'home.about2b': "compatibility with your car",
  'home.about2c': ": select the make, model, year and engine, or simply enter your number plate. The catalogue then only shows compatible parts, with their original (OE) references and cross-references between manufacturers so you can compare and choose with confidence.",
  'home.about3': "We only sell new parts from leading manufacturers (Bosch, Mann-Filter, TRW, Febi, Valeo…), covered by the 2-year legal warranty. A question about choosing a part, fitting it or checking compatibility? Our customer service team of car parts specialists replies quickly by chat, e-mail or phone.",
  'home.about4a': "Order your car parts in a few clicks with ",
  'home.about4b': "secure payment and delivery in 2 to 5 days",
  'home.about4c': " across France and Europe (home or pick-up point), 14-day returns and the option to book fitting at a partner centre. OTOPIECES.COM: spare parts at the right price, for every vehicle model.",
  'reviews.errRating': 'Choose a rating from 1 to 5 stars',
  'reviews.errShort': 'Your comment is too short (10 characters minimum)',
  'reviews.errSend': 'Error while sending your review',
  'reviews.verifiedCount': { one: '{n} verified review', other: '{n} verified reviews' },
  'reviews.withPhotos': { one: '{n} with photo', other: '{n} with photos' },
  'reviews.notAllowed': 'Only customers who ordered this product can leave a review.',
  'reviews.yourReviewOn': 'Your review of {name}',
  'reviews.invite': 'Thank you for taking the time to share your experience with this part.',
  'reviews.rewardTitle': 'Leave a review, get {percent}% off your next order',
  'reviews.rewardText': 'For customers who bought this product. Your personal code is issued as soon as your review is published (valid {days} days).',
  'reviews.rewardLogin': 'Sign in to leave a review',
  'reviews.rewardWrite': 'Write my review',
  'reviews.rewardAfterPurchase': 'Available after purchasing this product.',
  'reviews.rewardThanks': 'Thank you for your review! Here is your {percent}% code',
  'reviews.rewardCopy': 'Copy',
  'reviews.rewardCopied': 'Code copied',
  'reviews.rewardValidity': 'Enter it in your cart · valid until {date}, single use.',
  'reviews.rewardUsed': 'Code already used — thank you!',
  'reviews.rewardMinOrder': 'from {amount} € spent',
  'reviews.customerPhotos': 'Customer photos ({n})',
  'reviews.customerPhotosSee': 'See reviews',
  'reviews.customerPhotosHint': 'Real photos sent by verified buyers with their review. Click to enlarge.',
  'reviews.submit': 'Publish my review',
  'reviews.reported': 'Thank you, our team will check this review.',
  'questions.voteError': 'Vote failed',
  'questions.pending': 'Awaiting answer — visible only to you',
  'questions.errShort': 'Your question is too short (10 characters minimum)',
  'questions.errName': 'Enter your name',
  'questions.errEmail': 'Enter a valid e-mail to receive the answer',
  'questions.yourQuestionOn': 'Your question about {name}',
  'questions.send': 'Send my question',
  'tyre.summer': 'Summer tyre', 'tyre.winter': 'Winter tyre', 'tyre.allSeason': 'All-season tyre', 'tyre.car': 'Car', 'tyre.van': 'Van',
  'tyre.size': 'Size', 'tyre.indexes': 'Load / speed index', 'tyre.season': 'Season', 'tyre.vehicleType': 'Vehicle type', 'tyre.euLabel': 'EU label',
  'tyre.fuel': 'Fuel efficiency', 'tyre.wet': 'Wet grip', 'tyre.specifics': 'Features', 'tyre.xlSpec': 'XL (reinforced)', 'tyre.pcd': 'PCD', 'tyre.offset': 'Offset (ET)',
  'tyre.centerBore': 'Centre bore', 'tyre.material': 'Material', 'tyre.steel': 'Steel', 'tyre.aluminium': 'Aluminium', 'tyre.finish': 'Finish',
  'tyre.steelWheel': 'Steel wheel', 'tyre.aluWheel': 'Alloy wheel', 'tyre.snowflake': '3PMSF · mountain-law approved', 'tyre.xl': 'XL reinforced',
  'tyre.euLabelView': 'Full label & PDF', 'tyre.euLabelFull': 'European tyre label', 'tyre.fuelFull': 'Fuel efficiency', 'tyre.noiseFull': 'External rolling noise', 'tyre.snowGrip': 'Snow grip (3PMSF)', 'tyre.noSnowMark': 'No snow / ice marking', 'tyre.labelDisclaimer': 'Informative document based on supplier data; the official label is the manufacturer\'s.',
  'tyre.euLabelLine1': 'European', 'tyre.euLabelLine2': 'label', 'tyre.fuelHint': 'Energy efficiency (A = best)', 'tyre.wetGrip': 'Wet grip',
  'tyre.wetHint': 'Braking on wet roads (A = best)', 'tyre.noiseTitle': 'External rolling noise', 'tyre.noiseClass': 'Noise · class {c}',
  "acc.dashboard": "My OTOPIECES",
  "acc.garage": "My garage",
  "acc.maintenance": "Service book",
  "acc.maintenanceTitle": "Predictive service book",
  "acc.sellerListings": "My used-part listings",
  "acc.sellerImport": "Import my catalogue",
  "acc.sellerFeeds": "Catalogue synchronisation",
  "acc.sellerOrders": "My used-parts orders",
  "acc.seller": "Become a seller",
  "acc.pro": "Business account",
  "acc.orders": "My orders",
  "acc.wishlist": "My wishlist",
  "acc.addresses": "My address book",
  "acc.bank": "Bank details",
  "acc.wallet": "My store credit",
  "acc.settings": "Settings",
  "acc.compare": "Compare",
  "acc.logout": "Sign out",
  "acc.proValidated": "Verified business account",
  "acc.myAccount": "My account",
  "acc.proBannerOk": "Business account verified — {company}",
  "acc.proBannerPending": "Business account request under review ({company})",
  "acc.proBannerRefused": "Your business account request was refused",
  "acc.details": "Details",
  "acc.openOrders": "{n} in progress · {spent} spent",
  "acc.spent": "{spent} spent",
  "acc.walletCard": "Store credit",
  "acc.walletHint": "Credit usable at checkout",
  "acc.wishlistCard": "Wishlist",
  "acc.wishlistHint": "parts followed",
  "acc.vehiclesHint": "saved vehicle(s)",
  "acc.addressesCard": "Address book",
  "acc.addressesHint": "address(es)",
  "acc.cards": "{n} card(s)",
  "acc.ibanYes": "IBAN saved",
  "acc.ibanNo": "No IBAN",
  "acc.lastOrder": "Last order",
  "acc.viewOrders": "View my orders",
  "acc.proCta": "Are you an automotive professional?",
  "acc.proCtaSub": "Request your business account: prices excl. VAT, invoices in your company name, Pro badge.",
  "acc.personalInfo": "Personal information",
  "acc.savedAddress": "Saved shipping address",
  "acc.password": "Password",
  "acc.prefs": "Display & notification preferences",
  "acc.language": "Language",
  "acc.currency": "Currency",
  "acc.orderEmails": "Order tracking e-mails (confirmation, shipping)",
  "acc.marketing": "Personalised offers and promotions",
  "acc.delete": "Delete my account",
  "acc.deleteInfo": "Your addresses, vehicles, lists and cards will be erased. Your invoices remain available from our customer service.",
  "acc.deleteConfirm": "Delete permanently",
  "acc.currentPwd": "Current password *",
  "acc.newPwd": "New password * (8 characters min.)",
  "acc.confirmPwd": "Confirm new password *",
  "acc.showPwd": "Show",
  "acc.hidePwd": "Hide",
  "acc.pwdWord": "passwords",
  "acc.docLang": "Document language (invoices, e-mails)",
  "acc.defaultShipping": "Default shipping address",
  "acc.defaultBilling": "Default billing address",
  "acc.addressesInfo": "Your addresses are offered at checkout. The default shipping address is pre-filled automatically.",
  "acc.bankAccount": "Bank account (refunds)",
  "acc.bankInfo": "Used only to refund you in case of return or cancellation.",
  "acc.saveIban": "Save IBAN",
  "acc.cardsInfo": "To order faster. The full number is never stored.",
  "acc.default": "Default",
  "acc.remove": "Delete",
  "acc.save": "Save",
  "acc.history": "Transaction history",
  "acc.proInfo": "Garages, body shops, resellers: get prices excl. VAT, invoicing with your VAT number and a Pro badge.",
  "acc.editInfo": "Edit information",
  "acc.withdraw": "Withdraw my request",
  "acc.companyName": "Company name *",
  "acc.siret": "SIRET * (14 digits)",
  "acc.vatNumber": "EU VAT number",
  "acc.sector": "Business sector *",
  "acc.companyPhone": "Company phone",
  "acc.proof": "Proof (Kbis link / URL) — optional",
  "orders.loginPrompt": "Sign in to see your orders",
  "orders.login": "Sign in",
  "orders.empty": "You have not placed any order yet",
  "orders.order": "Order {n}",
  "orders.vehicle": "Vehicle",
  "orders.reorderVehicle": "Buy again for my car",
  "orders.reorderOk": "{n} item(s) added back to the cart",
  "orders.reorderPartial": "{n} item(s) added to the cart · {s} unavailable",
  "orders.reorderNone": "No item from this order is currently available.",
  "orders.filterVehicle": "Filter by vehicle",
  "orders.filterAll": "All",
  "orders.filterNoVehicle": "No vehicle",
  "orders.filterEmpty": "No orders for this vehicle.",
  "orders.cancelHint": "Changed your mind? You can cancel as long as the order is not being prepared.",
  "orders.cancel": "Cancel my order",
  "orders.cancelled": "This order has been cancelled.",
  "orders.refunded": "This order has been refunded.",
  "orders.tracking": "Parcel tracking — {carrier}",
  "orders.track": "Track my parcel",
  "orders.review": "Leave a review",
  "orders.walletUsed": "Credit used (store credit)",
  "orders.paid": "paid €{amount}",
  "orders.fittingAt": "Fitting at {name}",
  "orders.fitTyres": { one: "{n} tyre", other: "{n} tyres" },
  "orders.fitRequested": "Requested slot: {d} — awaiting confirmation by the centre.",
  "orders.fitConfirmed": "Appointment confirmed: {d}",
  "orders.fitContact": "The centre will contact you to arrange the appointment{p}.",
  "orders.fitReview": "Rate this fitting centre",
  "orders.fitRating": "Your rating of the centre: {r}/5 — thank you!",
  "appt.locked": "Appointment in less than {h} h: to change it, please contact the centre{p}.",
  "appt.actionFailed": "Action not possible",
  "appt.moved": "Appointment moved — the centre must confirm the new slot",
  "appt.requested": "Slot requested — the centre must confirm it",
  "appt.confirmCancel": "Cancel this appointment? The fitting is still planned; the centre will offer you another date.",
  "appt.cancelled": "Appointment cancelled — the centre has been notified",
  "appt.confirmCancelService": "Permanently cancel the fitting at {name}?\n\nThe fitting amount (€{a}) will be refunded as store credit on your account and a credit note PDF will be generated. Your tyres remain ordered.",
  "appt.serviceCancelled": "Fitting cancelled — €{a} credited to your store credit account",
  "appt.move": "Move the appointment",
  "appt.pick": "Choose a slot",
  "appt.cancelSlot": "Cancel the slot",
  "appt.cancelService": "Cancel the fitting (credit)",
  "appt.newSlot": "New slot at {name}",
  "appt.loadingCal": "Loading the calendar…",
  "appt.noCalendar": "This centre has no online calendar: enter your preferred date (at least {h} h in advance); the centre will confirm.",
  "appt.request": "Request this slot",
  "appt.centreConfirms": "The centre receives an e-mail and confirms the slot.",
  "appt.changes": { one: "{n} appointment change — last: {last}", other: "{n} appointment changes — last: {last}" },
  "appt.chCancelled": "cancellation",
  "appt.chReassigned": "reassigned to {c}",
  "appt.chMoved": "moved to {d}",
  "orders.cancelledToast": "Order cancelled. Items have been restocked.",
  "orders.cancelError": "Unable to cancel this order",
  "status.En attente": "Pending",
  "status.En cours": "Processing",
  "status.Expédié": "Shipped",
  "status.Livré": "Delivered",
  "status.Annulée": "Cancelled",
  "status.Remboursée": "Refunded",
  "cat.products": "Products",
  "cat.found": { one: "{n} product found", other: "{n} products found" },
  "cat.filterBy": "Filter by",
  "cat.brand": "Brand",
  "cat.noBrand": "No brand",
  "cat.price": "Price (€)",
  "cat.noneFilters": "No product matches your filters",
  "cat.noneVehicle": "No part compatible with your vehicle in this category",
  "cat.none": "No product found in this category",
  "cat.related": "Related searches",
  "cat.filters": "Filters",
  "search.filterCategory": "Category",
  "search.noneWithFilters": "No result with these filters.",
  "cat.sortRelevance": "Relevance",
  "cat.sortPriceAsc": "Price: low to high",
  "cat.sortPriceDesc": "Price: high to low",
  "cat.sortRating": "Highest rated",
  "cat.sortDiscount": "Best discounts",
  "cat.sortNewest": "Newest",
  "cat.bestPriceTitle": "Show only products where OTOPIECES is cheaper than all tracked competitors",
  "cat.sortBy": "Sort by",
  "cat.collapse": "Collapse",
  "cat.moreSubs": "See the {n} other subcategories",
  "cat.yourVehicle": "Your vehicle",
  "cat.onlyCompatible": "Show only compatible parts",
  "cat.allParts": "Show all parts",
  "cat.change": "Change",
  "acc.newsletter": "Receive OTOPIECES.COM offers and newsletter",
  "acc.changePwd": "Change password",
  "acc.deleteOpen": "I want to delete my account",
  "acc.confirmYourPwd": "Confirm your password",
  "acc.addrLabel": "Label (Home, Workshop…)",
  "acc.addrLabelPh": "Home",
  "acc.myAddresses": "My addresses ({n}/10)",
  "acc.addAddress": "Add an address",
  "acc.noAddress": "No address saved yet.",
  "acc.shipDefault": "Default shipping",
  "acc.setShipping": "Set for shipping",
  "acc.billDefault": "Default billing",
  "acc.setBilling": "Set for billing",
  "acc.holder": "Account holder *",
  "acc.savedCards": "Saved cards ({n}/5)",
  "acc.addCard": "Add a card",
  "acc.noCard": "No card saved.",
  "acc.month": "Month *",
  "acc.year": "Year *",
  "acc.txCredit": "Credit added",
  "acc.txDebit": "Debit",
  "acc.txOrder": "Used on order",
  "acc.txRefund": "Refund as credit",
  "acc.balance": "Available balance",
  "acc.walletUsage": "Automatically usable at checkout (\"Use my store credit\" box).",
  "acc.noTx": "No transactions yet.",
  "acc.proPending": "Request under review",
  "acc.proRefused": "Request refused",
  "acc.resend": "Resend request",
  "acc.requestPro": "Request a business account",
  "cat.showResults": "Show {n} product(s)",
  "tw.searchTyres": "Search tyres",
  "tw.tyres": "Tyres",
  "tw.searchWheels": "Search wheels",
  "tw.wheels": "Wheels",
  "tw.byVehicle": "By vehicle",
  "tw.vehicle": "Vehicle",
  "tw.title": "Tyres, wheels and accessories",
  "tw.counts": "{t} tyres, {w} wheels",
  "tw.defaultTitle": "Tyres and wheels",
  "tw.metaTitle": "Car tyres and wheels — search by size or by vehicle",
  "tw.metaDesc": "Find your summer, winter and all-season tyres by size (205/55 R16) or by vehicle (original sizes), and your alloy or steel wheels by PCD, offset and centre bore.",
  "tw.intro": "Search tyres by exact size (width, height, diameter, indexes), by vehicle (manufacturer original sizes) or wheels by PCD, offset and centre bore. Premium and budget brands, fast delivery, fitting available at a partner centre.",
  "tw.oeSubtitle": "Original sizes for {label}",
  "tw.accessoriesTitle": "Tyre & wheel accessories",
  "tw.accessoriesSub": "Bolts, locks, TPMS sensors, snow chains, jacks and all equipment around the wheel.",
  "tw.articles": { one: "{n} item", other: "{n} items" },
  "tw.comingSoon": "Coming soon",
  "tw.popularSizes": "Most common sizes",
  "tw.allSeasons": "Tyres for every season",
  "tw.brands": "Tyre and wheel brands",
  "tw.guideTitle": "{k}: the OTOPIECES guide",
  "tw.about": "About: {n}",
  "tw.faqTitle": "Frequently asked questions: {n}",
  "tw.summer": "Summer",
  "tw.winter": "Winter",
  "tw.fourSeasons": "All-season",
  "tw.vt.voiture": "Car",
  "tw.vt.suv": "4x4 / SUV",
  "tw.vt.utilitaire": "Van",
  "tw.vt.4x4": "4x4",
  "tw.quickSearch": "Quick search by size",
  "tw.quickSearchEx": "— e.g. 205 / 55 R16 91V",
  "tw.howToRead": "How do I read my tyre?",
  "tw.width": "Width",
  "tw.height": "Height",
  "tw.diameter": "Diameter",
  "tw.loadIndex": "Load index",
  "tw.speedIndex": "Speed index",
  "tw.widthPh": "Width (e.g. 205)",
  "tw.heightPh": "Height (e.g. 55)",
  "tw.diameterPh": "Diameter (e.g. R16)",
  "tw.season": "Season",
  "tw.advanced": "Select by parameters",
  "tw.brand": "Brand",
  "tw.model": "Model",
  "tw.allBrands": "All brands",
  "tw.modelPh": "e.g. Primacy, CrossClimate…",
  "tw.homologation": "Homologation (e.g. MO, *, AO)",
  "tw.optional": "Optional",
  "tw.priceMin": "Minimum price (€)",
  "tw.priceMax": "Maximum price (€)",
  "tw.priceMinShort": "Min price (€)",
  "tw.priceMaxShort": "Max price (€)",
  "tw.runflat": "Run-flat (RunFlat)",
  "tw.runflatHint": "Lets you drive ~80 km at 80 km/h after a puncture",
  "tw.xl": "Reinforced (XL)",
  "tw.xlHint": "Increased load capacity",
  "tw.ms": "Mud / snow (M+S)",
  "tw.snowflake": "Snow grip (3PMSF)",
  "tw.studded": "Studded",
  "tw.reset": "Reset filters",
  "tw.tyresInCatalog": "{n} tyres in the catalogue",
  "tw.wheelsInCatalog": "{n} wheels in the catalogue",
  "tw.wheelSpecs": "Wheel specifications",
  "tw.wheelSpecsEx": "— e.g. 7J x 17 — 5x112 — ET45 — Centre bore 66.6 mm",
  "tw.widthJ": "Width (J)",
  "tw.widthJPh": "Width (e.g. 7J)",
  "tw.diameterInPh": "Diameter (e.g. 17\")",
  "tw.holes": "Number of holes",
  "tw.holesPh": "Holes (e.g. 5)",
  "tw.pcd": "PCD",
  "tw.pcdPh": "PCD (e.g. 112)",
  "tw.et": "Offset (ET)",
  "tw.etPh": "Offset (e.g. ET45)",
  "tw.centerBore": "Centre bore",
  "tw.centerBorePh": "Centre bore (e.g. 66.6)",
  "tw.material": "Material",
  "tw.type": "Type",
  "tw.color": "Colour / finish",
  "tw.allF": "All",
  "tw.allM": "All",
  "tw.wheelModelPh": "e.g. TZ, Ultraleggera…",
  "tw.mat.aluminium": "Aluminium",
  "tw.mat.acier": "Steel",
  "tw.type.alu": "Alloy wheel",
  "tw.type.tole": "Steel wheel",
  "tw.type.ete": "Summer wheel",
  "tw.type.hiver": "Winter wheel",
  "tw.outOfStock": "Out of stock",
  "tw.leadDays": "Within {n} days",
  "tw.inStock": "In stock · shipped within 24 h",
  "tw.pcdShort": "PCD",
  "tw.offset": "Offset",
  "tw.bore": "Centre bore",
  "tw.finish": "Finish",
  "tw.perUnit": "each · €{p} for 4",
  "tw.viewProduct": "View product",
  "tw.tyresFound": { one: "{n} tyre found", other: "{n} tyres found" },
  "tw.wheelsFound": { one: "{n} wheel found", other: "{n} wheels found" },
  "tw.sortPriceAsc": "Price: low to high",
  "tw.sortPriceDesc": "Price: high to low",
  "tw.sortRating": "Highest rated",
  "tw.sortBrand": "Brand A→Z",
  "tw.noResults": "No results for these criteria",
  "tw.noResultsHint": "Widen your search: remove an index or an option.",
  "tw.eu.title": "EU label",
  "tw.eu.fuel": "Fuel",
  "tw.eu.wet": "Wet grip",
  "tw.eu.noise": "Noise",
  "tw.eu.onlyA": "A only",
  "tw.eu.aTo": "A to {g}",
  "tw.eu.noiseA": "≤ 68 dB (class A)",
  "tw.eu.noiseB": "≤ 71 dB (class B)",
  "tw.eu.noise75": "≤ 75 dB",
  "tw.eu.snowflake": "3PMSF (Mountain law)",
  "tw.vs.pickAtLeast": "Choose at least a brand and a model",
  "tw.vs.notFound": "Vehicle not found",
  "tw.vs.select": "Select your vehicle",
  "tw.vs.selectSub": "— we show the tyre and wheel sizes fitted as original equipment",
  "tw.vs.showOE": "Show original sizes",
  "tw.vs.reset": "Reset",
  "tw.vs.searching": "Looking up manufacturer fitments for {v}… (up to 30 s the first time)",
  "tw.vf.tyresAvail": { one: "{n} tyre available", other: "{n} tyres available" },
  "tw.vf.wheelsAvail": { one: "{n} wheel available", other: "{n} wheels available" },
  "tw.vf.none": "No items yet",
  "tw.vf.notFound": "Original sizes not available for {v}",
  "tw.vf.notFoundHint": "Read the size on the sidewall of your tyre (e.g. 205/55 R16 91V) and use the search by size.",
  "tw.vf.switch": "Search by size →",
  "tw.vf.oeFor": "Manufacturer original sizes for",
  "tw.vf.aiNotice": "Sizes generated automatically from manufacturer data and awaiting verification by our team. Before ordering, confirm the size printed on the sidewall of your current tyre.",
  "tw.vf.oeTyres": "Original tyres",
  "tw.vf.oeWheels": "Original wheels",
  "tw.vf.thread": "Thread",
  "tw.vf.diameters": "Diameters",
  "tw.vf.seeTyres": "See compatible tyres",
  "tw.vf.seeWheels": "See compatible wheels",
  "tw.vf.in": "in {s}",
  "tw.vc.year": "Year",
  "tw.vc.engine": "Engine",
  "tw.vc.pickBrand": "Choose a brand",
  "tw.vc.pickModel": "Choose a model",
  "tw.vc.selBrand": "Select a brand",
  "tw.vc.pickYear": "Choose the year",
  "tw.vc.selModel": "Select a model",
  "tw.vc.allEngines": "All engines",
  "tw.vc.selYear": "Select the year",
  "tw.vc.hp": "hp",
  "tw.sg.title": "How to read your tyre size?",
  "tw.sg.sub": "Everything is printed on the tyre sidewall. Hover or tap each part of the example",
  "tw.sg.width": "Width",
  "tw.sg.widthDesc": "Tyre width in millimetres, measured sidewall to sidewall (here 205 mm).",
  "tw.sg.height": "Height (aspect ratio)",
  "tw.sg.heightDesc": "Sidewall height as a % of the width: 55% of 205 mm ≈ 113 mm. The smaller the number, the lower the profile.",
  "tw.sg.radial": "Construction",
  "tw.sg.radialDesc": "R = radial construction, the standard on all modern cars.",
  "tw.sg.diameter": "Rim diameter",
  "tw.sg.diameterDesc": "Inner diameter of the tyre = diameter of your wheel, in inches (16\" ≈ 40.6 cm).",
  "tw.sg.load": "Load index",
  "tw.sg.loadDesc": "Maximum load per tyre: 91 = 615 kg. Never go below the index recommended by the manufacturer.",
  "tw.sg.speed": "Speed index",
  "tw.sg.speedDesc": "Maximum permitted speed: T 190 km/h · H 210 · V 240 · W 270 · Y 300. A winter tyre may have a lower index (minimum H in France if ≥ vehicle top speed − 1 category).",
  "tw.sg.where": "Where to find it?",
  "tw.sg.whereText": "On the sidewall of your current tyre, on the label inside the driver's door opening, in the fuel filler flap or in the service book. You can also use the tab",
  "tw.sg.whereEnd": "to find the original sizes.",
  "auth.loginTitle": "Sign in",
  "auth.loginSub": "Access your OTOPIECES.COM account",
  "auth.sessionExpired": "Your session has expired. Please sign in again.",
  "auth.email": "Email",
  "auth.password": "Password",
  "auth.emailPh": "you@email.com",
  "auth.passwordPh": "Your password",
  "auth.remember": "Keep me signed in",
  "auth.rememberDays": "(30 days)",
  "auth.forgot": "Forgot your password?",
  "auth.loggingIn": "Signing in...",
  "auth.login": "Sign in",
  "auth.noAccount": "Don't have an account yet?",
  "auth.createAccount": "Create an account",
  "auth.emailRequired": "Email required",
  "auth.passwordRequired": "Password required",
  "auth.badCredentials": "Incorrect email or password",
  "auth.registerSub": "Create your account to track your orders and save your vehicles",
  "auth.firstName": "First name",
  "auth.lastName": "Last name",
  "auth.firstNamePh": "John",
  "auth.lastNamePh": "Smith",
  "auth.emailPh2": "john.smith@email.com",
  "auth.phone": "Phone (optional)",
  "auth.phonePh": "+44 7700 900123",
  "auth.min8": "Minimum 8 characters",
  "auth.confirmPassword": "Confirm password",
  "auth.repeatPh": "Repeat the password",
  "auth.acceptPrefix": "I accept the",
  "auth.terms": "terms and conditions",
  "auth.and": "and the",
  "auth.privacy": "privacy policy",
  "auth.newsletter": "I would like to receive offers and promotions by email",
  "auth.sessionHint": "You will stay signed in for 30 days on this device.",
  "auth.creating": "Creating account...",
  "auth.createMine": "Create my account",
  "auth.haveAccount": "Already have an account?",
  "auth.firstNameRequired": "First name required",
  "auth.lastNameRequired": "Last name required",
  "auth.emailInvalid": "Invalid email",
  "auth.passwordsMismatch": "Passwords do not match",
  "auth.acceptRequired": "You must accept the terms",
  "auth.registerError": "Registration failed",
  "auth.forgotTitle": "Forgot password",
  "auth.forgotMeta": "Reset the password of your OTOPIECES.COM account.",
  "auth.forgotIntro": "Enter your email address: we will send you a link to choose a new password.",
  "auth.checkInbox": "Check your inbox",
  "auth.sentBefore": "If an account exists for",
  "auth.sentAfter": ", an email with a reset link (valid for 1 hour) has just been sent.",
  "auth.spam": "Remember to check your spam folder.",
  "auth.backLogin": "Back to sign in",
  "auth.emailAddress": "Email address",
  "auth.sendLink": "Send the reset link",
  "auth.emailAddressInvalid": "Invalid email address",
  "auth.genericError": "Something went wrong, please try again in a moment",
  "auth.resetTitle": "New password",
  "auth.resetMeta": "Choose a new password for your OTOPIECES.COM account.",
  "auth.account": "Account:",
  "auth.linkIncomplete": "Incomplete link: open the link you received by email.",
  "auth.linkInvalid": "Invalid or expired link",
  "auth.requestNew": "Request a new link",
  "auth.changed": "Password changed!",
  "auth.redirecting": "You are now signed in. Redirecting…",
  "auth.newPassword": "New password",
  "auth.min8Ph": "At least 8 characters",
  "auth.saveNew": "Save the new password",
  "auth.min8Long": "The password must contain at least 8 characters",
  "auth.cannotChange": "Unable to change the password",
  "auth.tooMany": "Too many requests. Please try again in 15 minutes.",
  "auth.linkInvalidDetail": "This reset link is invalid or has expired. Please request a new one.",
  "common.loading": "Loading…",
  "search.parts": "{b} Parts",
  "search.metaQuery": "Search “{q}”",
  "search.metaDefault": "Parts Search",
  "search.metaDesc": "Search results for {q} on OTOPIECES.COM: {n} product(s) found.",
  "search.brandPage": "View brand page",
  "search.resultsFor": "Results for “{q}”",
  "search.title": "Search",
  "search.noMatch": "No product matches “{q}”",
  "search.hint": "Enter a keyword, brand or reference",
  "search.showUnfiltered": "View the {n} results unfiltered by vehicle",
  "brands.metaTitle": "All car parts brands from A to Z",
  "brands.metaDesc": "Discover the {n} spare parts brands available on OTOPIECES.COM{list}. Original quality and 2-year warranty.",
  "brands.all": "All brands",
  "brands.countAZ": { one: "{n} spare parts brand, listed from A to Z", other: "{n} spare parts brands, listed from A to Z" },
  "brands.searchPh": "Search for a brand…",
  "brands.noMatch": "No brand matches “{q}”.",
  "search.nearTitle": "Did you mean… close references",
  "search.nearVia": "via ref.",
  "partRequest.cta": "Request this part",
  "partRequest.ctaHint": "We source the part from our suppliers and get back to you by e-mail within 24 business hours.",
  "partRequest.title": "Request this part",
  "partRequest.intro": "Leave your details: our team checks availability and price, then replies by e-mail.",
  "partRequest.msgSearch": "Part searched",
  "partRequest.msgVehicle": "Vehicle",
  "partRequest.msgDetails": "Details",
  "partRequest.detailsPh": "Useful details: OEM reference, side (left/right), year, photo of the part…",
  "partRequest.submit": "Send my request",
  "partRequest.sent": "Request sent!",
  "partRequest.sentDesc": "An acknowledgement has been e-mailed to you; we will get back to you shortly.",
  "cat.topRated": "4 ★ and up",
  "cat.topRatedTitle": "Show only parts rated 4/5 or more by our customers",
  "brands.sortBy": "Sort:",
  "brands.sortAz": "A → Z",
  "brands.sortTrust": "Trust score",
  "brands.noReviews": "No reviews yet",
  "brands.trustHint": { one: "{n} brand rated by our customers — best rated first, then brands without reviews alphabetically.", other: "{n} brands rated by our customers — best rated first, then brands without reviews alphabetically." },
  "brand.notFound": "Brand not found",
  "brand.metaCat": "{c} {b} — Car parts",
  "brand.metaTitle": "{b} Parts — Catalogue and prices",
  "brand.metaDesc": "All {b} spare parts: {n} product(s) in {cats}. Original quality, 2-year warranty, fast delivery in France.",
  "brand.noProducts": "No “{b}” products in our catalogue.",
  "brand.eyebrow": "Parts brand",
  "brand.products": { one: "{n} product", other: "{n} products" },
  "brand.categories": { one: "{n} category", other: "{n} categories" },
  "cmp.title": "Product comparison",
  "cmp.addFailed": "Unable to add",
  "cmp.price": "Price incl. VAT",
  "cmp.oldPrice": "Strikethrough price",
  "cmp.discount": "Discount",
  "cmp.rating": "Customer rating",
  "cmp.availability": "Availability",
  "cmp.inStock": "In stock",
  "cmp.outOfStock": "Out of stock",
  "cmp.ref": "Reference",
  "cmp.subcategory": "Sub-category",
  "cmp.soldBy": "Sold by",
  "cmp.pack": "pack",
  "cmp.packs": "Packaging",
  "cmp.warranty": "Warranty",
  "cmp.twoYears": "2 years",
  "cmp.compat": "Compatibility",
  "cmp.universal": "Universal",
  "cmp.intro": "{n}/{max} products · add parts from the same category from product cards (balance icon).",
  "cmp.clear": "Clear comparison",
  "cmp.empty": "Your comparison is empty",
  "cmp.emptyHint": "Browse the catalogue and click the balance icon to compare up to {max} parts.",
  "cmp.browse": "View parts",
  "cmp.remove": "Remove",
  "nf.metaTitle": "Page not found (404)",
  "nf.title": "This part is not in the catalogue…",
  "nf.text": "The requested page has been moved, deleted or never existed. No need to worry: the right path is just below.",
  "nf.searchPh": "Search for a part, a reference, a brand…",
  "nf.search": "Search",
  "nf.topCategories": "Most searched categories",
  "wl.guestBefore": "Your list is saved on this device.",
  "wl.guestLogin": "Sign in",
  "wl.guestAfter": "to find it everywhere and keep it.",
  "chat.tooShort": "Describe your request in a few words (10 characters minimum).",
  "chat.failed": "Unable to send, please try again.",
  "chat.open": "Contact customer service",
  "chat.greeting": "Hello! Ask your question, and an adviser will reply by email.",
  "chat.another": "Send another message",
  "chat.sent": "Message sent!",
  "chat.replyTime": "Reply by email within 24 working hours",
  "chat.reference": "Reference",
  "chat.messagePh": "Type your message...",
  "chat.emailPh": "Your email",
  "chat.namePh": "Your name",
  "contact.sent": "Message sent",
  "contact.failed": "Unable to send",
  "contact.address": "Address",
  "contact.phoneWa": "Telephone / WhatsApp",
  "contact.hours": "Opening hours",
  "contact.metaDesc": "Contact OTOPIECES.COM customer service: telephone, email, form. Reply within 24 working hours.",
  "contact.heading": "A question? We’ll answer.",
  "contact.intro": "Part compatibility, order tracking, returns or invoice: our team of car enthusiasts is here to help.",
  "contact.tracking": "Tracking",
  "contact.returns": "Returns",
  "contact.writeUs": "Write to us",
  "contact.ackSent": "An acknowledgement of receipt has been sent to you by email; we will reply within 24 working hours.",
  "contact.message": "Message",
  "contact.received": "Message received!",
  "contact.fullName": "Full name",
  "contact.newMessage": "New message",
  "contact.orderNo": "Order no. (optional)",
  "contact.subject": "Subject",
  "contact.phone": "Telephone",
  "contact.privacyNote": "Your data is used only to process your request.",
  "contact.messagePh": "Describe your request (vehicle, part reference, issue encountered…)",
  "contact.details": "Our contact details",
  "contact.send": "Send",
  "chat.page": "Page:",
  "chat.send": "Send",
  "orders.invoicePdf": "PDF invoice",
  "cat.all": "All",
  "cat.filterSubs": "Filter {n} sub-categories…",
  "cat.noSubMatch": "No sub-category matches « {q} »",
  "cat.otherSubs": "Other sub-categories {name}",
  "cat.subsubs": "Sub-categories of {name}",
  "xsell.badge": "Useful add-on",
  "xsell.compatible": "Fits your vehicle",
  "xsell.addedTitle": "Added to cart",
  "xsell.completeTitle": "Complete your purchase",
  "xsell.completeHint": "The essentials for the job — your choice.",
  "xsell.continue": "Continue shopping",
  "xsell.cartTitle": "Essentials for your service",
  "xsell.cartHint": "Useful complementary products for the parts in your cart.",
  "xsell.productTitle": "Complementary products",
  "xsell.productHint": "Often needed for this job.",
  "cat.quickFilters": "Quick filters",
  "cat.quickFiltersHint": "Pick a {name} sub-category and a brand: the right part in two clicks.",
  "cat.nProducts": { one: "{n} product", other: "{n} products" },
  "banner.discover": "Discover",
  "banner.prev": "Previous banner",
  "banner.next": "Next banner",
  "banner.n": "Banner {n}",
  "about.title": "About us",
  "about.eyebrow": "About",
  "about.heading": "{name}, car parts made easy",
  "about.intro": "Born from the frustration of never finding the right part number, our shop brings together manufacturer catalogues, expert advice and express delivery.",
  "about.description": "{name}: the French specialist in online car parts. Our story, our values, our team.",
  "about.kpiRefs": "references in stock",
  "about.kpiMakers": "original equipment manufacturers",
  "about.kpiBrands": "vehicle brands",
  "about.kpiShip": "dispatch time",
  "about.kpiShipValue": "24 h",
  "about.storyTitle": "Our story",
  "about.story1": "It all starts in an independent garage: too much time wasted searching for a part number, too many compatibility errors, too many delays. We decided to build the tool we would have wanted: an exact catalogue by engine, supplier prices and delivery that keeps its promise.",
  "about.story2": "Today, private customers and professionals order brake, filtration, timing, suspension or bodywork parts from {name} from the biggest brands — TRW, Bosch, Brembo, Valeo, Mann-Filter, LuK… — with the guarantee of the right part, at the right price.",
  "about.promiseLabel": "Our promise",
  "about.promise": "“The right part, delivered fast, at the right price — and a human on the end of the line if needed.”",
  "about.valuesTitle": "Our values",
  "about.v1Title": "The right part, first time",
  "about.v1Text": "Compatibility verified by exact engine variant and number plate lookup: zero reference errors.",
  "about.v2Title": "Fair pricing",
  "about.v2Text": "Direct purchase from original equipment manufacturers, tiered pricing and transparent trade rates.",
  "about.v3Title": "Fast delivery, safely delivered",
  "about.v3Text": "Dispatched within 24 hours, partner carriers and real-time tracking to your door.",
  "about.v4Title": "Responsible",
  "about.v4Text": "Recycled packaging, returned items refurbished and certified partners.",
  "about.teamTitle": "The team",
  "about.t1Name": "Customer Service",
  "about.t1Role": "Response within 24 working hours",
  "about.t2Name": "Technical experts",
  "about.t2Role": "Mechanics & bodywork specialists",
  "about.t3Name": "Logistics",
  "about.t3Role": "Preparation & dispatch",
  "about.t4Name": "Purchasing",
  "about.t4Role": "Manufacturer selection",
  "about.joinTitle": "Would you like to join us or work with us?",
  "about.joinText": "Careers, partnerships, press: let’s talk.",
  "about.careers": "Careers",
  "about.contact": "Contact us",
  "ret.title": "Warranty & returns",
  "ret.description": "14-day returns, 2-year warranty on all OTOPIECES.COM parts. Return process in 4 steps.",
  "ret.heading": "Money-back guarantee, 2-year warranty",
  "ret.intro": "A reference error, a part that does not fit? Returns are simple and refunds are quick.",
  "ret.k1": "14 days",
  "ret.k1Text": "to change your mind",
  "ret.k2": "2 years",
  "ret.k2Text": "manufacturer's warranty",
  "ret.k3": "5 days",
  "ret.k3Text": "to be refunded",
  "ret.stepsTitle": "Returning a part in 4 steps",
  "ret.s1Title": "Register the return",
  "ret.s1Text": "From « My orders », cancel or contact us, stating the order number and the part concerned.",
  "ret.s2Title": "Pack the part",
  "ret.s2Text": "Unfitted part, in its original packaging with the invoice. We will send you the return label.",
  "ret.s3Title": "Drop off the parcel",
  "ret.s3Text": "At a post office or parcel shop within 14 days. Tracking will inform us of receipt.",
  "ret.s4Title": "Refund",
  "ret.s4Text": "Within 5 days after inspection: to your payment method or as an immediate credit on your deposit account.",
  "ret.coveredTitle": "Covered by the warranty",
  "ret.covered1": "Manufacturing or material defect",
  "ret.covered2": "Part not compliant with the ordered reference",
  "ret.covered3": "Breakage or missing part on delivery",
  "ret.covered4": "Premature failure under normal use conditions",
  "ret.notCoveredTitle": "Not covered",
  "ret.notCovered1": "Part fitted, used or modified",
  "ret.notCovered2": "Normal wear and tear (pads, discs, filters…)",
  "ret.notCovered3": "Installation not in accordance with the manufacturer's recommendations",
  "ret.notCovered4": "Return outside the 14-day period or without the original packaging",
  "ret.ctaTitle": "Ready to return a part?",
  "ret.ctaText": "Go to your orders to cancel or request a return, or contact our customer service.",
  "ret.ctaOrders": "Request a return",
  "ret.ctaContact": "Contact us",
  "sm.title": "Site map",
  "sm.description": "All pages on OTOPIECES.COM: parts categories, brands, customer area, information.",
  "sm.eyebrow": "Navigation",
  "sm.intro": "See all the shop sections at a glance.",
  "sm.shop": "Shop",
  "sm.account": "My account",
  "sm.help": "Help",
  "sm.home": "Home",
  "sm.allParts": "All parts",
  "sm.brandsAZ": "Brands A to Z",
  "sm.guides": "Guides & advice",
  "sm.compare": "Comparator",
  "sm.cart": "Basket",
  "sm.myOto": "My OTOPIECES",
  "sm.garage": "My garage",
  "sm.pro": "Professional account",
  "sm.orders": "My orders",
  "sm.wishlist": "My wish list",
  "sm.addresses": "Address book",
  "sm.bank": "Bank details",
  "sm.wallet": "Deposit account",
  "sm.settings": "Settings",
  "sm.login": "Sign in",
  "sm.register": "Register",
  "sm.contact": "Contact",
  "sm.shipping": "Delivery & tracking",
  "sm.returns": "Warranty & returns",
  "sm.about": "About us",
  "sm.sitemap": "Site map",
  "sm.categories": "Parts categories",
  "sm.vehicleBrands": "Vehicle makes",
  "sm.makers": "Equipment manufacturers",
  "sm.pages": "Information & legal pages",
  "garage.title": "My vehicles",
  "garage.add": "Add a vehicle",
  "garage.intro": "Save your vehicles to find compatible parts in one click. By adding your registration number, it will be recognised by registration number search after validation by our team.",
  "garage.selectRequired": "Select the make, model and year",
  "garage.addedPlate": "Vehicle added — its registration number will be recognised by registration number search after validation by our team",
  "garage.added": "Vehicle added",
  "garage.addError": "Error when adding the vehicle",
  "garage.confirmDelete": "Delete {name}?",
  "garage.deleted": "Vehicle deleted",
  "garage.newVehicle": "New vehicle",
  "garage.brand": "Make *",
  "garage.model": "Model *",
  "garage.year": "Year *",
  "garage.engine": "Engine",
  "garage.hp": "hp",
  "garage.platePh": "Registration number (optional) — AA-123-BB",
  "garage.labelPh": "Nickname (optional) — e.g. Marie’s car",
  "garage.cancel": "Cancel",
  "garage.save": "Save",
  "garage.empty": "No vehicles registered yet.",
  "garage.plateValidated": "Registration number validated",
  "garage.plateRefused": "Registration number refused",
  "garage.platePending": "Registration number pending validation",
  "garage.useSelected": "Selected vehicle · View parts",
  "garage.use": "Use this vehicle",
  "garage.delete": "Delete",
  "mb.mileage": "Current mileage",
  "mb.mileagePh": "e.g. 85000",
  "mb.yearly": "Miles / year (estimate)",
  "mb.save": "Save",
  "mb.overdueKm": "overdue by {n} km",
  "mb.inKm": "in {n} km",
  "mb.overdueDays": "overdue by {n} days",
  "mb.inDays": "in {n} days",
  "mb.lastPurchase": "last purchase {date}",
  "mb.seeParts": "View parts",
  "mb.noVehicle1": "Add a vehicle in",
  "mb.noVehicleLink": "My garage",
  "mb.noVehicle2": "to activate your predictive service book.",
  "mb.estimated": "estimated today",
  "mb.enterMileage": "Please enter your mileage to receive your maintenance due dates (timing belt, brakes, filters…).",
  "mb.alertsTitle": "Alerts sent",
  "mb.see": "View",
  "mb.diagTitle": "My photo checks",
  "mb.diagEmpty": "No requests. The « Check my part by photo » button is available on technical product pages.",
  "mb.partToIdentify": "Part to identify",
  "mb.confirmed": "Reference confirmed",
  "mb.rejected": "Not identified",
  "mb.pending": "Awaiting approval",
  "mb.ref": "Ref. {ref}",
  "mb.aiLead": "AI lead: {ref} ({c} %)",
  "mb.seePart": "View part",
  "promo.copyCode": "Copy code",
  "promo.copied": "Code copied!",
  "winter.myTyres": "See my winter tyres",
  "winter.seeTyres": "See winter tyres",
  "winter.close": "Close",
  "cat.reset": "Reset",
  "cat.resetFilters": "Reset filters",
  "cat.guideTitle": "{kw}: the OTOPIECES guide",
  "cat.aboutTitle": "About: {name}",
  "cat.faqTitle": "Frequently asked questions: {name}",
  "search.seeAll": "See all results for “{q}”",
  "product.refLabel": "Ref.",
  "content.notFound": "Page not found",
  "content.backHome": "Back to home",
  "content.updatedOn": "Updated on {date}",
  "blog.title": "OTOPIECES.COM Magazine",
  "blog.intro": "Discover our practical guides, maintenance tips and tricks to take care of your vehicle.",
  "blog.searchPh": "Search an article...",
  "blog.empty": "No article found",
  "blog.featured": "Featured article",
  "blog.notFound": "Article not found",
  "blog.backToList": "Back to guides",
  "blog.readTime": "{time} read",
  "blog.share": "Share:",
  "blog.related": "Related articles",
  "blog.popular": "Popular topics",
  "blog.catOil": "Engine oil",
  "blog.catBrakes": "Brakes",
  "blog.catMaintenance": "Maintenance",
  "blog.catElectric": "Electrical",
  "blog.nArticles": { "one": "{n} article", "other": "{n} articles" },
  "blog.video1": "How to save money when buying car parts?",
  "blog.video2": "What to do if the engine warning light comes on",
  "blog.video3": "TOP 8 mistakes made by car owners",
  "frev.l1": "Very disappointing",
  "frev.l2": "Disappointing",
  "frev.l3": "Fair",
  "frev.l4": "Good",
  "frev.l5": "Excellent",
  "frev.invalidLink": "Invalid link",
  "frev.sendError": "Could not send",
  "frev.title": "Your review of the centre",
  "frev.intro": "Hello {name}, your {n} tyre(s) were fitted at",
  "frev.on": "on",
  "frev.order": "order",
  "frev.thanks": "Thank you for your review!",
  "frev.already": "You have already rated this centre.",
  "frev.replyFrom": "Reply from {author}",
  "frev.backShop": "Back to the shop",
  "frev.question": "How did your fitting appointment go?",
  "frev.clickStar": "Click a star",
  "frev.comment": "Your comment (optional)",
  "frev.commentPh": "Welcome, punctuality, fitting quality…",
  "frev.submit": "Send my review",
  "notif.title": "Notifications",
  "notif.empty": "No notifications yet.",
  "notif.maintenanceLink": "My service book",
  "notif.agoMin": "{n} min ago",
  "notif.agoH": "{n} h ago",
  "notif.agoD": "{n} d ago",
  "notif.refConfirmed": "Reference confirmed for your part",
  "notif.photoRequest": "Your photo check request",
  "notif.fittingMoved": "Fitting appointment rescheduled",
  "notif.fittingConfirmed": "Fitting appointment confirmed",
  "notif.fittingTomorrow": "Your tyres are fitted tomorrow",
  "notif.maintenance": "Maintenance due: {sub} ({vehicle})",
  "notif.k.diag_auto.title": "Part reference confirmed",
  "notif.k.diag_auto.body": "Reference {ref} ({brand}) confirmed by photo analysis: {explanation}",
  "notif.k.diag_rejected.title": "Your photo verification request",
  "notif.k.diag_rejected.body": "{message}",
  "notif.k.diag_rejected_default.title": "Your photo verification request",
  "notif.k.diag_rejected_default.body": "We could not identify the part in your photo. Please try again with a sharper photo or contact our customer service.",
  "notif.k.diag_admin.title": "Part reference confirmed",
  "notif.k.diag_admin.body": "Our team has checked your photo: the reference to order is {ref}{brand_suffix}. {message}",
  "notif.k.maintenance_km.title": "Maintenance due: {sub} ({vehicle})",
  "notif.k.maintenance_km.body": "Based on your mileage, your {sub} is due in about {km} km. Here are the parts compatible with your {vehicle}.",
  "notif.k.maintenance_now.title": "Maintenance due: {sub} ({vehicle})",
  "notif.k.maintenance_now.body": "Based on your mileage, your {sub} is due now. Here are the parts compatible with your {vehicle}.",
  "notif.k.maintenance_days.title": "Maintenance due: {sub} ({vehicle})",
  "notif.k.maintenance_days.body": "Based on your mileage, your {sub} is due in {days} days. Here are the parts compatible with your {vehicle}.",
  "notif.k.fit_confirmed.title": "Fitting appointment confirmed",
  "notif.k.fit_confirmed.body": "{centre} ({city}) has confirmed your tyre fitting on {date} — order {order}.",
  "notif.k.fit_confirmed_requested.title": "Fitting appointment confirmed",
  "notif.k.fit_confirmed_requested.body": "{centre} ({city}) has confirmed your tyre fitting on {date} (requested slot: {requested}) — order {order}.",
  "notif.k.fit_moved.title": "Fitting appointment rescheduled",
  "notif.k.fit_moved.body": "{centre} ({city}) has moved your appointment to {date} — order {order}.",
  "notif.k.fit_reminder.title": "Your tyre fitting is tomorrow",
  "notif.k.fit_reminder.body": "Reminder: appointment on {date} at {centre}, {address}.",
  "notif.k.fit_reassigned_kept.title": "New fitting centre",
  "notif.k.fit_reassigned_kept.body": "Your tyre fitting (order {order}) is now handled by {centre} — {address}. Your slot on {date} is kept, pending confirmation by the centre.",
  "notif.k.fit_reassigned_propose.title": "New fitting centre",
  "notif.k.fit_reassigned_propose.body": "Your tyre fitting (order {order}) is now handled by {centre} — {address}. The centre will propose a date.",
  "notif.k.fit_review_reply.title": "The centre replied to your review",
  "notif.k.fit_review_reply.body": "{centre}: “{excerpt}”",
  "notif.k.fit_cancelled_credit.title": "Fitting cancelled — credit note issued",
  "notif.k.fit_cancelled_credit.body": "Credit note {number} for {amount} added to your deposit account (order {order}).",
  "notif.k.fit_card_refund.title": "Credit note refunded to your payment method",
  "notif.k.fit_card_refund.body": "Credit note {number} for {amount} has been refunded to your {method} (bank processing 3 to 10 days).",
  "acc.notifications": "Notifications",
  "notif.seeAll": "See all my notifications",
  "nc.kind.all": "All",
  "nc.kind.fitting": "Fitting",
  "nc.kind.diagnostic": "Photo diagnostic",
  "nc.kind.maintenance": "Maintenance",
  "nc.unreadOnly": "Unread only",
  "nc.readAll": "Mark all as read",
  "nc.prefs": "Preferences",
  "nc.markRead": "Mark as read",
  "nc.markUnread": "Mark as unread",
  "nc.delete": "Delete",
  "nc.empty": "No notifications for this filter.",
  "nc.prev": "Previous",
  "nc.next": "Next",
  "nc.pageOf": "Page {page} / {pages}",
  "nc.prefsTitle": "Notification preferences",
  "nc.prefsIntro": "For each type of notification, choose whether you also want to receive it by e-mail or only in the site's bell.",
  "nc.emailAndBell": "E-mail + bell",
  "nc.bellOnly": "Bell only",
  "nc.transactionalNote": "Essential e-mails (order confirmation, shipping, invoice, credit note, password) are always sent.",
  "nc.ch.diagnostic": "Photo diagnostic",
  "nc.chDesc.diagnostic": "Reference confirmed or verification request handled by our team.",
  "nc.ch.maintenance": "Maintenance due",
  "nc.chDesc.maintenance": "Maintenance reminders based on your vehicles' mileage.",
  "nc.ch.fitting": "Tyre fitting",
  "nc.chDesc.fitting": "Appointment confirmed or moved, day-before reminder, change of centre.",
  "nc.ch.reviews": "Reviews & replies",
  "nc.chDesc.reviews": "Invitations to leave a review and replies from the centre or our team to your reviews.",
  "nc.ch.alerts": "Price alerts, wishlist & questions",
  "nc.chDesc.alerts": "Price drop or back in stock for a followed item, answers to your product questions.",
  "ps.title": "Partner centre space",
  "ps.invalidLink": "Invalid link",
  "ps.savedSchedule": "Hours saved: customers can now book a slot with you.",
  "ps.saveFailed": "Could not save",
  "ps.savedLang": "Language saved: {lang}.",
  "ps.langFailed": "Language not saved",
  "ps.perTyre": "/ tyre",
  "ps.langHint": "Language of this space and of the e-mails we send you",
  "ps.langLabel": "Language",
  "ps.slotsTitle": "My fitting slots",
  "ps.slotsIntro": "Enter your opening ranges per day: customers will pick a free slot when ordering and you will receive an e-mail to confirm it.",
  "ps.upcomingTitle": "Upcoming appointments",
  "ps.noUpcoming": "No upcoming appointments.",
  "ps.nTyres": "{n} tyre(s)",
  "ps.toConfirm": "To confirm",
  "ps.confirmed": "Confirmed",
  "ps.confirm": "Confirm",
  "ps.edit": "Edit",
  "ps.reviewsTitle": "My customers' reviews",
  "ps.reviewsIntro": "Your replies are public (visible to customers when choosing a centre); the customer is notified by e-mail on your first reply.",
  "ps.noReviews": "No reviews yet.",
  "ps.slotDuration": "Slot duration",
  "ps.leadDays": "Minimum lead time (days, tyre delivery)",
  "ps.capacity": "Vehicles per slot",
  "ps.weekPreset": "Typical week (Mon–Fri 8–12 / 14–18, Sat 9–12)",
  "ps.addRange": "range",
  "ps.closed": "Closed",
  "ps.rangeError": "Each range must end after it starts.",
  "ps.saveSchedule": "Save hours",
  "ps.ofScore": "{n} % of the score",
  "ps.noDelay": "No confirmation measured yet",
  "ps.delayUnderHour": "Average confirmation delay: under an hour",
  "ps.delayAvg": "Average confirmation delay: {d} (100 if ≤ 12 h, 0 beyond 96 h)",
  "ps.dayShort": "d",
  "ps.relTitle": "My reliability",
  "ps.relWindow": "over the last {n} days, updated live",
  "ps.relIntro": "Customers see the most reliable centres first. A “Watch” score (under 40) over at least {n} orders temporarily hides the centre at checkout.",
  "ps.visible": "Offered to customers",
  "ps.hidden": "Hidden at checkout",
  "ps.since": "since {d}",
  "ps.relEmpty": "No orders in the period yet: your score will appear after the first fitting.",
  "ps.barConfirmed": "Confirmed appointments",
  "ps.confirmedOf": "{c} confirmed out of {o} order(s)",
  "ps.pendingN": "{n} awaiting your confirmation",
  "ps.barDelay": "Response speed",
  "ps.barKept": "Orders kept",
  "ps.reassignedN": "{n} order(s) reassigned to another centre for lack of response",
  "ps.noReassigned": "No order reassigned — perfect",
  "ps.pointsTitle": "Points to improve",
  "ps.keepGoing": "Keep it up",
  "ps.excellent": "Excellent score: you appear at the top of the list for nearby customers.",
  "ps.ratingLine": "Customer rating: {avg}/5 from {count} reviews · {upcoming} upcoming appointments.",
  "ps.histEmpty": "History available from the first week with orders.",
  "ps.histTitle": "Score trend over {n} weeks",
  "ps.calTitle": "Add my appointments to my calendar",
  "ps.calIntro": "Subscribe your calendar to this link: fittings (confirmed and pending) appear automatically in Google Calendar, Outlook or Apple Calendar, refreshed hourly.",
  "ps.copied": "Copied",
  "ps.copyLink": "Copy link",
  "ps.subscribe": "Subscribe (Apple / Outlook)",
  "ps.downloadIcs": "Download .ics",
  "ps.calGoogle": "Other calendars (+) → “From URL” → paste the link.",
  "ps.calOutlook": "Add calendar → “Subscribe from web” → paste the link.",
  "ps.calApple": "File → New Calendar Subscription, or click “Subscribe”.",
  "ps.sendFailed": "Could not send",
  "ps.deleteReplyConfirm": "Delete your reply?",
  "ps.editReply": "Edit my reply",
  "ps.reply": "Reply",
  "ps.replyPlaceholder": "Thank you for your feedback…",
  "ps.publicReply": "public reply",
  "ps.customerNotified": "the customer is notified by e-mail",
  "ps.publish": "Publish",
  "ps.stValidated": "Validated on {d}",
  "ps.stDisputed": "Disputed on {d} — pending review",
  "ps.stResolved": "Dispute handled on {d}",
  "ps.actionFailed": "Action failed",
  "ps.stFittings": {"one": "{count} fitting", "other": "{count} fittings"},
  "ps.stUpcoming": "{n} upcoming",
  "ps.currentMonth": "current month",
  "ps.reason": "Reason:",
  "ps.answer": "Answer:",
  "ps.validateConfirm": "Validate the {m} statement ({a} incl. VAT)? This is final.",
  "ps.validate": "Validate statement",
  "ps.dispute": "Dispute",
  "ps.disputeReason": "Reason for the dispute (missing fitting, wrong amount…)",
  "ps.disputePlaceholder": "E.g.: the fitting for order OP-… on 12/09 is missing from the statement.",
  "ps.sendDispute": "Send dispute",
  "ps.cancel": "Cancel",
  "ps.stTitle": "My monthly statements",
  "ps.stIntro": "Each statement summarises the fittings confirmed and performed at your centre and the amount (incl. VAT) to invoice us. Once the month is over, validate it before issuing your invoice, or dispute it if a fitting or amount is wrong.",
  "ps.trend": "{d} pt since {since}",
  "rel.excellent": "Excellent",
  "rel.good": "Good",
  "rel.average": "Average",
  "rel.watch": "Watch",
  "rel.noData": "Not enough data",
  "rel.tip": "Confirmation {c} % · Response delay {d}/100 · Reassignments suffered {r} ({rs}/100) · {n} order(s)",
  "rel.detail": "conf. {c} % · delay {d} · reassign. {r}",
  "rel.weekTip": "Week of {d}: {s}/100 ({l}, {n} order(s))",
  "nc.pushEnabledBg": "Notifications enabled (even when the site is closed)",
  "nc.pushTest": "Send me a test notification",
  "nc.pushTestResult": "Test notification sent to {sent} device(s) out of {devices}.",
  "nc.pushTestNone": "No subscribed device: enable notifications on this device first.",
  "ps.pushIntro": "Get alerted on this device, even when this space is closed, as soon as a customer books, moves or cancels a fitting slot, or a fitting is reassigned to you.",
  "nc.ch.digest": "Weekly summary",
  "nc.chDesc.digest": "Every Monday morning, an e-mail summarising your unread notifications of the week (off by default).",
  "nc.digestOn": "On",
  "nc.digestOff": "Off",
  "nc.pushTitle": "Browser notifications",
  "nc.pushDesc": "Get an alert on your device as soon as a fitting appointment is confirmed or moved, or a new notification arrives — even when the site is closed (Web Push).",
  "nc.pushEnable": "Enable browser notifications",
  "nc.pushEnabled": "Browser notifications enabled",
  "nc.pushDisable": "Disable",
  "nc.pushDenied": "Notifications blocked by the browser: allow them in the site settings.",
  "nc.pushUnsupported": "Your browser does not support notifications.",
  "track.title": "Delivery tracking",
  "track.created": "Order confirmed",
  "track.createdDesc": "Your payment was approved, we are preparing your order.",
  "track.processing": "Being prepared",
  "track.processingDesc": "Your parts are being checked and packed in our warehouse.",
  "track.handed_over": "Parcel handed to carrier",
  "track.shipped": "Shipped",
  "track.shippedDesc": "Your parcel is on its way.",
  "track.transit": "In transit",
  "track.delivered": "Delivered",
  "track.deliveredDesc": "Your parcel has been delivered. Enjoy the ride!",
  "track.pending": "Upcoming",
  "track.eta": "Estimated delivery: {d}",
  "track.carrierLink": "Track with {carrier}",
  "track.noNumber": "The tracking number will be shared as soon as your order ships.",
  "track.help": "A question about your delivery? Every step is displayed here in real time.",
  "track.lastUpdate": "Last update: {d}",
  "nc.ch.cart": "Cart reminder",
  "nc.chDesc.cart": "An e-mail if you leave items in your cart for 24 hours.",
  "nc.kind.delivery": "Delivery",
  "nc.ch.delivery": "Delivery tracking",
  "nc.chDesc.delivery": "A new delivery step added to your order (preparation, transit, delivery).",
  "notif.k.delivery_step.title": "New delivery update — order {order}",
  "notif.k.delivery_step.body": "{step}{loc} Track your parcel in real time in My orders.",
  "notif.k.delivery_processing.title": "Your order {order} is being prepared",
  "notif.k.delivery_processing.body": "Your parts are being checked and packed in our warehouse. Next step: shipping.",
  "notif.k.delivery_shipped.title": "Your order {order} has been shipped",
  "notif.k.delivery_shipped.body": "Your parcel is on its way{loc}. Find the tracking number in My orders.",
  "notif.k.delivery_delivered.title": "Your order {order} has been delivered",
  "notif.k.delivery_delivered.body": "Your parcel has arrived. Enjoy the ride! Feel free to review your parts.",
  "paylink.invalid": "This payment link is invalid.",
  "paylink.fillCard": "Please fill in all card details.",
  "paylink.failed": "The payment could not be processed.",
  "paylink.paid": "This order has already been paid. Thank you!",
  "paylink.expired": "This payment link has expired. Contact us to receive a new one.",
  "paylink.revoked": "This link has been replaced by a new one: check your latest e-mail.",
  "paylink.cancelled": "This order has been cancelled.",
  "paylink.successTitle": "Payment confirmed",
  "paylink.successBody": "Thank you! Your order {o} is confirmed and will be prepared right away. A confirmation e-mail has been sent.",
  "paylink.orderFor": "Order prepared for {n}",
  "paylink.toPay": "To pay",
  "paylink.cardTitle": "Secure card payment",
  "paylink.holder": "Cardholder name",
  "paylink.payNow": "Pay {a}",
  "paylink.secure": "Encrypted connection · Your card details are never stored.",
  "orders.awaitingPayment": "Awaiting payment",
  "orders.payNow": "Pay now",
  "checkout.sumupInfo": "You will be redirected to the secure SumUp payment page to enter your card details. Your order is confirmed as soon as the payment is accepted.",
  "checkout.walletCoversAll": "Your credit covers the full order: no card payment is required.",
  "checkout.redirecting": "Redirecting to secure payment…",
  "checkout.errPayment": "The order has been recorded but payment could not be started. Please try again or pay later from 'My orders'.",
  "checkout.retryPayment": "Retry payment",
  "paylink.sumupInfo": "You will be redirected to the secure SumUp payment page (bank card, Apple Pay, Google Pay).",
  "payret.checking": "Checking your payment…",
  "payret.checkingHint": "Please wait a few seconds while we confirm the payment with SumUp.",
  "payret.paidTitle": "Payment confirmed!",
  "payret.paidBody": "Thank you for your order. A confirmation email has been sent to you and your order will now be prepared.",
  "payret.failedTitle": "Payment unsuccessful",
  "payret.failedBody": "The payment was declined or cancelled. No amount has been debited. Your items remain reserved: you can try again.",
  "payret.pendingTitle": "Payment awaiting confirmation",
  "payret.pendingBody": "We have not yet received confirmation from SumUp. If you have paid, your order will automatically change to 'Paid' in a few minutes.",
  "payret.retry": "Retry payment",
  "payret.later": "Pay later",
  "payret.errorTitle": "Order not found",
  "orders.refundCard": "Order refunded to your bank card ({a} €) — credit note {n}.",
  "orders.refundCardPartial": "Partial refund of {a} € made to your bank card — credit note {n}.",
  "orders.creditNotePdf": "Download the credit note (PDF)",
  "product.viewSpecs": "Specifications",
  "product.fitOk": "Fits your vehicle",
  "product.fitUniversal": "Universal product: fits all vehicles",
  "product.fitKo": "Does not fit your vehicle",
  "product.fitSeeCompatible": "See compatible parts",
  "product.fitChangeVehicle": "Change vehicle",
  "product.fitSelectHint": "Select your vehicle to check compatibility",
  "product.fitSelectCta": "Select my vehicle",
  "cmp.check": "Compare",
  "cmp.checked": "In comparison",
  "cmp.added": "Added to comparison ({n}/{max})",
  "cmp.removed": "Removed from comparison",
  "cmp.maxReached": "You can compare up to {max} items",
  "cmp.sameSub": "Only compare items from the same subcategory",
  "cmp.open": "Compare",
  "cmp.barTitle": "Comparison",
  "cmp.barHint": "Tick 2 to {max} items from the same subcategory",
  "cmp.barCompare": "Compare ({n})",
  "cmp.barNeedTwo": "Add at least 2 items",
  "cmp.colHeader": "Feature",
  "cmp.specsTitle": "Technical specifications",
  "cmp.diffHint": "Highlighted rows show differences between the items.",
  "cmp.intro2": "{n}/{max} items · tick “Compare” on product cards from the same subcategory.",
  "cmp.emptyHint2": "Browse the catalogue and tick “Compare” on 2 to {max} items from the same subcategory.",
  "header.fastShipping": "Fast 2-5 day delivery",
  "product.deliverySubFast": "2 to 5 working days",
  "cart.fastShipping": "Fast 2-5 day delivery",
  "cart.freeShippingReached": "Free shipping unlocked!",
  "header.deliveryCountry": "Delivery country",
  "header.freeFromShort": "free from €{n}",
  "sess.title": "Connected devices",
  "sess.hint": "Sessions currently signed in to your account. Sign out a device you don't recognise, or all the others at once.",
  "sess.logoutEverywhere": "Sign out everywhere",
  "sess.logout": "Sign out",
  "sess.thisDevice": "This device",
  "sess.lastSeen": "Last activity",
  "sess.remembered": "remembered",
  "sess.revoked": "Device signed out",
  "sess.revokedAll": "{n} device(s) signed out",
  "sess.confirmAll": "Sign out all other devices? You will stay signed in here.",
  "sess.error": "Action failed, please retry",
  "sess.empty": "No active session",
  "cart.remove": "Remove",
  "cat.specs": "Technical specifications",
  "cat.specsHint": "Refine by dimension, type or technical reference.",
  "cat.showMore": "Show more ({n})",
  "cat.showLess": "Show less",
  "garage.savedToast": "Vehicle saved to your garage",
  "garage.restoredToast": "Your {v} was restored from your account",
  "garage.myVehicles": "My vehicles",
  "garage.manage": "Manage my garage",
  "cart.forVehicle": "Parts for your vehicle",
  "equiv.search": "Filter…",
  "equiv.allBrands": "All brands ({n})",
  "equiv.brand": "Brand",
  "equiv.ref": "Reference",
  "equiv.type": "Type",
  "equiv.oem": "Manufacturer OEM",
  "equiv.alt": "Equivalent",
  "equiv.unknownBrand": "—",
  "equiv.empty": "No reference matches this filter.",
  "equiv.seeAll": "View all {n} references ↓",
  "equiv.moreAlt": "+{n} equivalents",
  "equiv.brandLink": "View all parts referencing {b}",
  "search.equivBrand": "Parts referencing {b}",
  "search.equivHint": "Parts from the {b} brand and parts from other manufacturers that list an equivalent {b} reference.",
  "cart.fitOk": "Compatible with your {v}",
  "cart.fitNo": "Not confirmed for your {v}",
  "cart.fitUniversal": "Universal part · all vehicles",
  "cart.fitCheck": "View the product details",
  "cart.fitWarn": { one: "{n} item is not confirmed for your {v}: check compatibility before ordering.", other: "{n} items are not confirmed for your {v}: check compatibility before ordering." },
  "alt.compatible": "Alternative compatible with your {v} at {brand}",
  "alt.samePrice": "same price",
  "alt.morePerUnit": "+{d} € / unit",
  "cart.garageSwitch": "Switch vehicle (my garage)",
  "cart.garagePick": "Pick a vehicle from my garage…",
  "cart.garageHint": "Item compatibility is re-checked instantly.",
  "notify.button": "Notify me when back in stock",
  "notify.title": "Back-in-stock alert",
  "notify.text": "Leave your e-mail: we'll write to you as soon as this part is available again (once, no strings attached).",
  "notify.emailPh": "your@email.com",
  "notify.submit": "Notify me",
  "notify.done": "Noted! You'll get an e-mail as soon as it's back in stock.",
  "notify.already": "You're already signed up for this part.",
  "notify.subscribed": "Alert on: you'll be notified by e-mail",
  "notify.cancel": "Cancel alert",
  "notify.error": "We couldn't save your request. Please check the e-mail address.",
  "notify.priceButton": "Notify me if the price drops",
  "notify.priceTitle": "Price-drop alert",
  "notify.priceText": "Leave your e-mail: we'll write to you as soon as this part gets cheaper (once, no strings attached).",
  "notify.priceDone": "Noted! You'll get an e-mail if the price drops.",
  "notify.priceAlready": "You're already watching this part's price.",
  "notify.priceSubscribed": "Price alert on: you'll be notified by e-mail",
  "acc.referral": "Referral",
  "share.rewardHint": "Get −{p} % when a friend places a first order through your link.",
  "share.rewardMore": "My rewards",
  "share.rewardGuest": "Sign in: get −{p} % when a friend orders through your link.",
  "share.rewardLogin": "Sign in",
  "share.refTitle": "Share and earn −{p} %",
  "share.refHow": "Every time a friend places their first order after opening a link you shared (page, product, comparison, guide), you receive by e-mail a personal −{p} % code valid {d} days. The site's share buttons automatically add your code to your links.",
  "share.refDisabled": "The programme is temporarily paused.",
  "share.refWhatsapp": "I order my car parts here, have a look:",
  "share.refTip": "Tip: share a product page or your vehicle selection directly — the link already contains your code.",
  "share.refTotal": "Rewards earned",
  "share.refActive": "Codes to use",
  "share.refRewards": "My codes",
  "share.refEmpty": "No reward yet: share your favourite parts with your friends!",
  "share.refStatus_active": "To use",
  "share.refStatus_used": "Used",
  "share.refStatus_expired": "Expired",
  "share.refFriend": "Friend {f} · {d}",
  "share.refUntil": "until {d}",
  "share.tier_none": "No rank yet",
  "share.tier_bronze": "Bronze referrer",
  "share.tier_silver": "Silver referrer",
  "share.tier_gold": "Gold referrer",
  "share.badgeFriends": "{n} friend(s) converted",
  "share.badgeNext": "{n} more friend(s) to reach {tier}",
  "share.badgeMax": "Top rank reached — thank you!",
  "share.badgeLevels": "Bronze from 1 friend · Silver from 3 · Gold from 10",
  "acc.alerts": "My alerts",
  "alerts.intro": "Your “Notify me” alerts: back in stock and price drops. Each alert sends you a single e-mail, then leaves this list.",
  "alerts.active": { one: "{n} active alert", other: "{n} active alerts" },
  "alerts.empty": "No active alert. On a product page, click “Notify me” to be told when a part is back in stock or gets cheaper.",
  "alerts.kindStock": "Back in stock",
  "alerts.kindPrice": "Price drop",
  "alerts.remove": "Remove",
  "alerts.removeAll": "Remove all",
  "alerts.removed": "Alert removed",
  "alerts.removedAll": "All alerts removed",
  "alerts.error": "Action failed, please retry",
  "alerts.since": "since {d}",
  "alerts.priceWatch": "Watched price: {p} €",
  "alerts.now": "today",
  "alerts.backSoon": "Back in stock — e-mail on its way",
  "alerts.history": "Alerts sent (last 90 days)",
  "alerts.sentOn": "sent on {d}",
  "wl.priceAlerts": "Price alerts on the whole list",
  "wl.priceAlertsHint": "Get an e-mail as soon as an item of your wishlist gets cheaper",
  "wl.priceAlertsDone": "Price alert enabled on {n} item(s) ({a} already watched). Find them under My alerts.",
  "equiv.showMore": "Show more ({n} more references)",
  "equiv.showLess": "Show less",
  "spec.equivalences": "Equivalent references",
  "header.matchesEan": "Matches EAN code ",
  "product.compatVerified": { one: "Compatibilities verified via {n} equivalent part", other: "Compatibilities verified via {n} equivalent parts" },
  "equiv.compareTitle": "Compare equivalents side by side",
  "equiv.compareSub": "{n} equivalent parts · the highlighted column is the part viewed",
  "equiv.openComparator": "Open in comparator",
  "equiv.current": "Part viewed",
  "equiv.colBrand": "Brand",
  "equiv.colRef": "Reference",
  "equiv.colPrice": "Incl. VAT price",
  "equiv.colRating": "Customer reviews",
  "equiv.colDelivery": "Delivery",
  "equiv.colStock": "Stock",
  "equiv.colType": "Type",
  "equiv.cheapest": "Cheapest",
  "equiv.bestRated": "Highest rated",
  "equiv.fastest": "fastest",
  "equiv.bestMarket": "Best market price",
  "equiv.stockLine": "{w} warehouse",
  "equiv.stockSupplier": " · +{s} supplier",
  "equiv.outOfStock": "Out of stock",
  "equiv.supplierDelay": "Within {n} days (supplier)",
  "equiv.ship24": "Dispatched within 24 h",
  "equiv.unavailable": "Unavailable",
  "equiv.viewProduct": "View product page",
  "equiv.hideCompare": "Hide comparison",
  "equiv.showCompare": "Show comparison",
  "common.close": "Close",
  "scan.title": "Scan the EAN barcode",
  "scan.hint": "Place the barcode of the part or its packaging within the frame: the product page opens automatically.",
  "scan.denied": "Camera access denied. Allow the camera in your browser, then try again.",
  "scan.unavailable": "Camera unavailable on this device. Enter the EAN code in the search bar.",
  "scan.found": "Part found: {name}",
  "equiv.share": "Share the comparison",
  "equiv.shareWhatsapp": "Send on WhatsApp",
  "equiv.shareCopy": "Copy link",
  "equiv.shareCopied": "Comparison link copied",
  "equiv.shareText": "Can you tell me which part to choose? OTOPIECES comparison: {names}",
  'cmp.shared': { one: 'Shared comparison — {n} part', other: 'Shared comparison — {n} parts' },
  "cmp.shareTitle": "Share this comparison",
  "fb.title": "Our leading brands",
  "fb.all": "All brands",
  "fb.nav": "Parts brands",
  "fb.parts": "{b} parts",
  "fb.logo": "{b} logo",
  "seo.defaultTitle": "Cheap car parts online — Spare parts for all makes",
  "seo.defaultDesc": "Car spare parts at the best price on OTOPIECES.COM: brakes, filters, engine, tyres… Search by vehicle or number plate, 2-5 day delivery, 14-day returns.",
  "vb.title": "Car parts by vehicle make",
  "vb.meta": "Choose your vehicle make (Renault, Peugeot, Volkswagen, BMW, Citroën…) to find all models and compatible spare parts.",
  "vb.crumb": "Vehicle makes",
  "vb.intro": "Select your car make to discover all its models and compatible spare parts: brakes, filtration, engine, tyres…",
  "vb.searchPh": "Search a make…",
  "vb.popular": "Best-selling makes",
  "vb.all": "All makes ({n})",
  "vb.models": { "one": "{n} model", "other": "{n} models" },
  "vb.brandTitle": "Cheap {b} car parts — all models",
  "vb.brandFallback": "Vehicle make",
  "vb.brandH1": "{b} car parts",
  "vb.brandStats": "{m} model(s) · {p} compatible part(s)",
  "vb.brandExcerpt": "Choose your {b} model below, then the year and engine to show only the parts that exactly fit your vehicle.",
  "vb.brandEmpty": "{b} models are coming soon.",
  "vb.selectVehicle": "Select a vehicle",
  "vb.topParts": "Most requested {b} compatible parts",
  "vb.faqTitle": "Frequently asked questions about {k}",
  "vb.faqParts": "{b} parts",
  "vb.notFound": "Make not found.",
  "vb.seeAll": "See all makes",
  "vm.notFound": "Model not found.",
  "vm.seeBrandModels": "See the make's models",
  "vm.useVehicle": "Use this vehicle for the whole catalogue",
  "vm.shareParts": "Share compatible parts",
  "vm.share": "Share…",
  "vm.empty": "No parts listed for this model yet.",
  "vm.otherModels": "See other {b} models",
  "vm.engineEmpty": "No parts listed for the “{e}” engine.",
  "vm.allEngines": "See all engines",
  "vm.frequent": "Frequent searches",
  "vm.wholeCategory": "Whole category",
  "vm.faqTitle": "FAQ — {car} parts",
  "vm.faqFitQ": "How can I be sure a part fits my {car}?",
  "vm.faqFitA": "Every part on this page is listed for the {model}. Click your engine above (or enter your number plate on the home page): only references compatible with your version remain displayed.",
  "vm.faqPartsQ": "Which parts are available for the {car}?",
  "vm.faqPartsA": "The {model} catalogue currently covers: {cats}. New references are added regularly.",
  "vm.faqPartsEmpty": "The {model} catalogue is being built.",
  "vm.faqDeliveryQ": "What are the delivery times?",
  "vm.faqDeliveryA": "In-stock parts ship within 24 h and are delivered in 2 to 5 working days. You can also book fitting at a partner centre when ordering.",
  "vm.h1": "{car} car parts",
  "vm.intro": "Find below all verified spare parts for the {car}. Select your engine to show only the references that exactly match it.",
  "vm.stats": "{e} engine(s) · {p} compatible part(s)",
  "vm.filtered": "{n} part(s){e}",
  "vm.forEngine": " for {e}",
  "vm.added": "Added to cart",
  "vm.addError": "Could not add to cart",
  "pp.noVehicleTitle": "No vehicle selected",
  "pp.noVehicleText": "Select your vehicle to show only compatible parts.",
  "pp.selectVehicle": "Select my vehicle",
  "pp.backHome": "Back to home",
  "pp.title": "Parts compatible with your vehicle",
  "pp.metaTitle": "Car parts compatible with your vehicle",
  "pp.metaDesc": "Select your vehicle (make, model, engine or number plate) and discover 100% compatible spare parts on OTOPIECES.COM.",
  "pp.metaTitleVehicle": "{v} car parts",
  "pp.metaDescVehicle": "All spare parts compatible with your {v}: brakes, filtration, engine, clutch… at the best price on OTOPIECES.COM.",
  "pp.categories": "Categories",
  "br.title": "The cheapest models to maintain: yearly parts budget ranking",
  "br.h1": "The cheapest models to maintain",
  "br.crumb": "Maintenance budget",
  "br.metaDefault": "Ranking of vehicle models by estimated yearly maintenance budget based on compatible parts.",
  "br.meta": "Ranking of {n} models by estimated yearly maintenance budget (compatible wear parts × usual frequency). From the most economical ({min}/year) to the most expensive ({max}/year), excluding labour.",
  "br.intro": "For each model we estimate the yearly maintenance parts budget from the compatible parts listed on OTOPIECES.COM: filters, brakes, spark plugs, belts, shock absorbers… multiplied by their usual replacement frequency. Median price of compatible parts, or “eco” budget with the cheapest part. Excluding labour, all engines combined.",
  "br.error": "Ranking unavailable at the moment.",
  "br.allBrands": "All makes ({n})",
  "br.itemStats": "{p} of {pt} items estimated · {n} compatible parts · {e} engines",
  "br.perYear": "/ year",
  "br.eco": "eco {v} / year",
  "br.footnote": "Ranking recomputed every night{d}. Indicative estimates, excluding labour.",
  "br.lastUpdate": " · last update {d}",
  "br.ctaQ": "Do you own one of these models?",
  "br.ctaLink": "Add it to your garage",
  "br.ctaRest": " for a budget on your exact engine, a service book and e-mail reminders.",
  "br.faqTitle": "Frequently asked questions",
  "br.faq1q": "How is the maintenance budget calculated?",
  "br.faq1a": "We use 22 wear items (oil change, filters, pads, discs, spark plugs, belts, timing, shock absorbers…). For each item, the median price of listed compatible parts is divided by the usual replacement frequency (e.g. pads every 2 years). The sum gives the smoothed yearly budget. A model only enters the ranking with at least 3 estimated items.",
  "br.faq2q": "Which model is the cheapest to maintain?",
  "br.faq2a": "According to our estimates, {car} comes first with about {m} of maintenance parts per year at median price ({e} in eco). The median of the {n} ranked models is {med}/year.",
  "br.faq3q": "Does the budget include labour?",
  "br.faq3a": "No: this is the parts budget only, all engines combined. Add your vehicle to your garage to get a budget for your exact engine, a service book with due dates in months and kilometres, and e-mail reminders.",
  "cm.pickError": "Choose two or three vehicles to compare from your garage.",
  "cm.failed": "Comparison failed",
  "cm.title": "Parts comparison: {v}",
  "cm.meta": "Common and specific compatible parts between {v}.",
  "cm.crumbGarage": "My garage",
  "cm.crumb": "Model comparison",
  "cm.parts": "{n} part(s)",
  "cm.forThisEngine": " for this engine",
  "cm.engines": " · {n} engine(s)",
  "cm.budget": "Maintenance budget ~{m} €/year",
  "cm.budgetEco": "(eco {e} €)",
  "cm.cheapest": "cheapest to maintain",
  "cm.budgetNone": "Maintenance budget not estimated",
  "cm.part": "Part",
  "cm.price": "Price",
  "cm.exactEngine": "My exact engine",
  "cm.allEngines": "All engines of the model",
  "cm.exactHint": "Only parts intended for each vehicle's engine (or without engine restriction) are compared.",
  "cm.allHint": "All parts of the model are compared, whatever the engine.",
  "cm.all": "All ({n})",
  "cm.common2": "Common to both ({n})",
  "cm.common3": "Common to all three ({n})",
  "cm.partial": "Common to two of three ({n})",
  "cm.only": "{m} only ({n})",
  "cm.onlyCol": "{m} only",
  "cm.common2Col": "Common to both",
  "cm.empty": "No parts in this selection.",
  "wl.title": "My wishlist",
  "wl.empty": "No parts saved. Click the heart on a product to find it here.",
  "acc.addressIntro": "Your addresses are offered at checkout. The default delivery address is pre-filled automatically.",
  "acc.walletIntro": "Your deposit account is credited by our customer service (refund as credit, goodwill gesture, voucher).",
  "acc.prefsNote": "The shop is available in 5 languages and in euros; your preferences are saved.",
  "acc.proHt": "Prices shown excl. VAT",
  "acc.proInvoices": "Invoices in your company's name",
  "acc.proBadge": "Pro badge on your account",
  "va.title": "Vehicle alerts",
  "va.intro": "Receive an e-mail when new parts compatible with your models are added — as a weekly summary (Monday) or at each addition.",
  "va.empty": "No vehicle alert. Enable one from a model page.",
  "va.browse": "Browse vehicles",
  "auth.showPassword": "Show password",
  "brands.kicker": "Our manufacturers",
  "brand.empty": "No {b} products{cat}{veh}.",
  "brand.emptyCat": " in this category",
  "brand.emptyVeh": " compatible with your vehicle",
  "brand.seeUnfiltered": "See the {n} products not filtered by vehicle",
  "brand.relatedSearches": "Related searches",
  "cmp.pageTitle": "Product comparison",
  "common.new": "New",
  "vm.metaDesc": "All spare parts compatible with the {car}: {cats}. {e} engine(s) ({engines}…). Verified compatibility, 2-5 day delivery.",
  "ship.title": "Delivery & tracking",
  "ship.metaDesc": "Delivery times, shipping costs and carriers at OTOPIECES.COM.",
  "ship.metaFree": "Free delivery from {free}.",
  "ship.eyebrow": "Delivery",
  "ship.heading": "Fast, tracked delivery",
  "ship.headingFree": "Fast, tracked delivery, free from {free}",
  "ship.intro": "Shipped within 24 working hours from our warehouse in France. Choose the carrier that suits you.",
  "ship.fees": "Shipping costs",
  "ship.feesFree": "{fee} · free from {free}",
  "ship.avgDelay": "Average time",
  "ship.avgDelayValue": "2 to 5 working days",
  "ship.insured": "Insured parcel",
  "ship.insuredValue": "Breakage or loss refunded",
  "ship.how": "How does it work?",
  "ship.s1": "Order confirmed",
  "ship.s1Text": "Immediate e-mail confirmation with your order number.",
  "ship.s2": "Preparation",
  "ship.s2Text": "Parts checked and packed within 24 working hours in our warehouse.",
  "ship.s3": "Shipping",
  "ship.s3Text": "E-mail with the tracking number and the carrier link.",
  "ship.s4": "Delivery",
  "ship.s4Text": "At home, at the garage or at a pick-up point, as you prefer.",
  "ship.carriers": "Our carriers",
  "ship.c1Delay": "2–4 working days",
  "ship.c1Note": "Home or post-office delivery",
  "ship.c2Delay": "24–48 h",
  "ship.c2Note": "Express, ideal for urgent workshop needs",
  "ship.c3Delay": "2–3 working days",
  "ship.c3Note": "Bulky parcels (bumpers, bonnets…)",
  "ship.c4Delay": "3–5 working days",
  "ship.c4Note": "Pick-up point collection, economical",
  "ship.trackingKicker": "Parcel tracking",
  "ship.trackingTitle": "Where is my order?",
  "ship.trackingText": "Find the status, carrier and tracking number in your customer account.",
  "ship.trackCta": "Track my order",
  "cat.metaSubFallback": "{sub} ({cat}) at the best price on OTOPIECES.COM: {brands}, guaranteed compatibility with your vehicle, 2-5 day delivery, 14-day returns.",
  "cat.metaFallback": "Buy your {cat} parts at the best price on OTOPIECES.COM: leading brands ({brands}), guaranteed compatibility with your vehicle, 2-5 day delivery.",
  "vg.today": "today",
  "vg.budgetInline": "maintenance budget ~{m} €/year",
  "vg.engines": "{m} engines",
  "vg.allN": "All ({n})",
  "vg.popular": "Popular",
  "vg.engAbbr": "{n} eng.",
  "vg.choose": "Choose",
  "vg.parts": "Parts",
  "vg.seeParts": "See all compatible parts for {m}",
  "vg.allModels": "All {b} models",
  "vg.searchModel": "Search a model…",
  "vg.gallery": "Gallery",
  "vg.list": "List",
  "vg.noMatch": "No model matches “{q}”.",
  "vg.popularTitle": "Most searched {b} models",
  "vg.popularByUsage": "Based on our customers' selections and garages.",
  "vg.popularByParts": "Models with the most parts available.",
  "vg.generations": { "one": "{n} generation", "other": "{n} generations" },
  "vg.yearsEstimated": "* indicative years",
  "mb.title": "Estimated yearly maintenance budget — {car}",
  "mb.intro": "Estimate based on the {n} compatible wear parts listed ({p} of {pt} items), all engines combined: median price, or “eco” with the cheapest part, divided by the usual replacement frequency.",
  "mb.eco": "Eco: {v} / year",
  "mb.hideDetail": "Hide details",
  "mb.showDetail": "See detail by item",
  "mb.rankingLink": "See the ranking of the cheapest models to maintain",
  "mb.garageLink": "Add this vehicle to your garage for a budget on your exact engine and a service book",
  "mb.colItem": "Item",
  "mb.colFreq": "Frequency",
  "mb.colEco": "Eco",
  "mb.colMedian": "Median price",
  "mb.colYear": "Per year",
  "mb.every": { "one": "every year", "other": "every {n} years" },
  "mb.missing": "Not estimated (no compatible part yet): {list}",
  "val.cta": "Alert me about new parts",
  "val.activated": "Alert enabled ({f}{e})!",
  "val.weeklyShort": "weekly summary",
  "val.instantShort": "at each addition",
  "val.already": "Alert already active",
  "val.active": "New-parts alert active",
  "val.disable": "Disable",
  "val.formTitle": "Receive an e-mail when new compatible parts are added",
  "val.emailPh": "your@email.com",
  "val.enable": "Enable",
  "val.onlyEngine": "Only my engine",
  "val.weekly": "Weekly summary (Monday)",
  "val.instant": "At each addition",
  "val.error": "Could not enable the alert, please check the e-mail address.",
  "val.notifyWhenAdded": "Notify me as soon as a part is added",
  "gar.alertEnabledNote": "“New parts” alert enabled (weekly summary).",
  "gar.alertOptIn": "E-mail me about new parts compatible with this vehicle",
  "gar.alertOptInHint": "(weekly summary, editable in My alerts)",
  "vb.brandMeta": "{b} spare parts: {m} models ({fams}…) and {p} compatible parts at the best price. Brakes, filtration, engine, tyres.",
  "vb.partsInCat": "{b} {c} parts ({n})",
  "vb.allParts": "All parts",
  "vb.noPartsInCat": "No parts in this category for this make yet.",
  "vb.modelFilter": "Filter by model",
  "vb.allModelsOpt": "All models",
  "vb.partsForModel": "Parts compatible with {b} ({n})",
  "vb.modelPage": "Model page",
  "vb.noPartsForModel": "No parts in this category compatible with this model yet.",
  "vb.modelsWithParts": "Models with listed parts",
  "vb.modelsOther": "Other models",
  "vb.engineFilter": "Filter by engine",
  "vb.allEnginesOpt": "All engines",
  "fuel.essence": "Petrol", "fuel.diesel": "Diesel", "fuel.hybride": "Hybrid", "fuel.essence/électrique": "Petrol hybrid", "fuel.diesel/électrique": "Diesel hybrid", "fuel.électrique": "Electric", "fuel.gpl": "LPG",
  "fuel.essence/gpl": "Petrol / LPG", "fuel.essence/éthanol": "Petrol / ethanol",
  "vb.garageAdd": "Add to my garage",
  "vb.garageSee": "In my garage — view",
  "vb.garageAdded": "{car} added to your garage.",
  "vb.garageAlready": "This vehicle is already in your garage.",
  "vb.garageError": "Could not add this vehicle.",
  "vb.garageLoginHint": "Sign in to save this vehicle in your garage",
  "vb.alertCta": "Alert me about new {m} parts",
  "vb.share": "Share this selection",
  "vb.shareText": "Compatible parts {sel} on OTOPIECES.COM",
  "vb.shareCopied": "Selection link copied to the clipboard.",
  "vb.shareCopiedShort": "Link copied",
  "vb.shareCopyManual": "Copy this link:",
  "vb.shareCheapest": "The 3 cheapest parts:",
  "vb.shareWhatsappHint": "Send the selection and the 3 cheapest parts via WhatsApp",
  "fuelR.title": "Fuel type",
  "fuelR.all": "All powertrains",
  "fuelR.essence": "Petrol",
  "fuelR.diesel": "Diesel",
  "fuelR.electrique": "100% electric",
  "fuelR.reserved": "Only for engines:",
  "fuelR.vehicleHint": "Relevance sort: {e} parts for your vehicle first",
  "product.fitFuelKo": "Only for {e} engines — your vehicle is {ve}",
  "cart.fitFuel": "{e} only · your {v} is {ve}",
  "garage.additivesTitle": "Recommended additives",
  "garage.additivesHint": "Additives and cleaners matching the fuel type of each of your vehicles.",
  "garage.additivesEmpty": "No compatible additive yet.",
  "garage.additiveHint": "Don't forget the additive:",
  "packEss.title": "Petrol service pack",
  "packEss.onAdditive": "on the additive",
  "packEss.desc": "This oil + a petrol fuel additive: -{p}% on the additive, discount applied automatically at checkout.",
  "packEss.total": "The pack:",
  "packEss.add": "Add the pack to cart",
  "packEss.done": "Pack added",
  "packEss.added": "Pack added to cart — code {c} applied",
  "packEss.addedLogin": "Pack added — the {c} discount applies at checkout once signed in",
  "packEss.code": "Discount via code {c}, valid with an engine oil in the cart.",
  "packEss.titleDiesel": "Diesel service pack",
  "packEss.descDiesel": "This oil + a diesel additive or DPF cleaner: -{p}% on the additive, discount applied automatically at checkout.",
  "packEss.cartDesc": "Your engine oil is alone in the cart: complete the pack with the matching additive, -{p}% on it.",
  "packEss.cartAdd": "Add the additive to the pack (-{p}%)",
};

export default en;
